"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5642],{

/***/ 809:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ MMTInsuranceHeader)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87109);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44928);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 //import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';






const DynamicMMTHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(() => Promise.all(/* import() */[__webpack_require__.e(8611), __webpack_require__.e(9681), __webpack_require__.e(1597), __webpack_require__.e(500), __webpack_require__.e(1285), __webpack_require__.e(2346), __webpack_require__.e(1516), __webpack_require__.e(7556), __webpack_require__.e(454), __webpack_require__.e(5802), __webpack_require__.e(3007), __webpack_require__.e(1359), __webpack_require__.e(3025), __webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.t.bind(__webpack_require__, 18972, 23)).then(module => module.Header), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(18972)]
  }
});
const DynamicLandingHeaderMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48359)).then(module => module.LandingHeaderMobile), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48359)]
  }
});
function MMTInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  isMyBiz,
  exitWebViewOnBack = false,
  showPwaHeaderBackButton = true,
  showPwaHeader = true
}) {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();

  let headerPropsWithDefaults = _objectSpread({
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    pokusExperiments: {
      insuranceNewFunnel: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCookieByName */ .A7)("isCommonLanding") === "true"
    },
    onLogin: () => {
      if ((0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCookieByName */ .A7)("next_page_req")) {
        window.location.href = `https://insurance.makemytrip.com/insurance/next-page`;
      } else next_router__WEBPACK_IMPORTED_MODULE_5___default().reload();
    },
    onLoginFlowComplete: () => void 0,
    onModalChange: () => void 0,
    showMoreButton: true,
    showLoginPersuasionSlider: false,
    multiLingualData: {
      "header.login.signup.for.best.prices": "Please login to purchase your travel insurance"
    },
    globalConfig: null,
    headerCommonData: {
      loyaltyHeaderData: null,
      walletHeaderData: null,
      mobileCore: null,
      userInfoData: null
    }
  }, headerProps);

  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }

  if (headerPropsWithDefaults?.forceLogin) {
    headerPropsWithDefaults = _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      activeModal: "LOGIN"
    });
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      "data-test-id": "DynamicMMTHeader"
    }));
  }

  return isMyBiz && device === "lg" ? null : device === "lg" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
    "data-test-id": "DynamicMMTHeader"
  })) : showPwaHeader ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicLandingHeaderMobile, {
    headerTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_3__.PARTNER.MMT,
    insuranceHeader: true,
    exitWebViewOnBack: exitWebViewOnBack,
    showPwaHeaderBackButton: showPwaHeaderBackButton,
    "data-test-id": "DynamicLandingHeaderMobile"
  }) : null;
}

/***/ }),

/***/ 94782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XU": () => (/* binding */ InfoText),
/* harmony export */   "eN": () => (/* binding */ TitleText),
/* harmony export */   "jP": () => (/* binding */ ManageInsuranceStyleShimmer),
/* harmony export */   "w7": () => (/* binding */ ManageInsuranceStyle)
/* harmony export */ });
/* unused harmony export ManageInsuranceInfo */
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44928);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);



const ManageInsuranceStyle = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyle",
  componentId: "zxsmvf-0"
})(["background:linear-gradient(46.21deg,#f7f4ff 0.78%,#dceaff 97.21%),#ffffff;border:1px solid #ffffff;border-radius:16px;padding:10px 16px;position:relative;overflow:hidden;> img{position:absolute;top:-7px;right:-7px;}svg{fill:#fff;}"]);
const ManageInsuranceInfo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceInfo",
  componentId: "zxsmvf-1"
})(["margin-bottom:8px;font-size:12px;line-height:16px;color:#4a4a4a;span{font-weight:800;}"]);
const ManageInsuranceStyleShimmer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ManageInsurancestyle__ManageInsuranceStyleShimmer",
  componentId: "zxsmvf-2"
})(["background:#e2e2e2;border-radius:4px;height:176px;padding:16px;display:flex;"]);
const TitleText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .ParaTagStyle */ .OG).withConfig({
  displayName: "ManageInsurancestyle__TitleText",
  componentId: "zxsmvf-3"
})(["max-width:200px;font-size:16px;font-weight:900;margin-bottom:8px;"]);
const InfoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .ParaTagStyle */ .OG).withConfig({
  displayName: "ManageInsurancestyle__InfoText",
  componentId: "zxsmvf-4"
})(["width:95%;font-size:12px;margin-bottom:8px;color:#4a4a4a;@media ", "{width:80%;}"], _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_0__.deviceType.mobile);

/***/ }),

/***/ 49442:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(576);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48359);
/* harmony import */ var _ManageInsurance_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94782);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const ManageInsurance = ({
  title,
  info,
  orderBtn,
  handleManageOrder,
  goHomeText,
  orderBtnIcon,
  goHomeBtnIcon
}) => {
  const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__/* .getAnalytics */ .I)();

  const gotoHome = () => {
    analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "go_home_clicked"
    });
    _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_1__/* .navigationActions.navigateToLanding */ .ej.navigateToLanding({
      type: ""
    }); // navigationActions.navigateToRouteNameWithHostname(
    //   ROUTE_CONSTANTS.COMMON_LANDING,
    //   { type: "" }
    // );
    //TODO: aDD This once we have the common landing page for seo
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_ManageInsurance_style__WEBPACK_IMPORTED_MODULE_3__/* .ManageInsuranceStyle */ .w7, {
    "data-test-id": "ManageInsurance-ManageInsuranceStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
      width: "104px",
      height: "104px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/manage_Ins_Bg_410326bba8.svg",
      "data-test-id": "ManageInsurance-ImageComponent"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ManageInsurance_style__WEBPACK_IMPORTED_MODULE_3__/* .TitleText */ .eN, {
      "data-test-id": "ManageInsurance-TitleText",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
        value: title,
        "data-test-id": "ManageInsurance-FormattedText"
      })
    }), info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_ManageInsurance_style__WEBPACK_IMPORTED_MODULE_3__/* .InfoText */ .XU, {
      "data-test-id": "ManageInsurance-InfoText",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
        value: info,
        "data-test-id": "ManageInsurance-FormattedText"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.LandingButton, {
      btnRightIcon: orderBtnIcon,
      customWidth: "100%",
      customTitle: orderBtn,
      onClick: handleManageOrder,
      "data-test-id": "ManageInsurance-LandingButton"
    }), goHomeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
      margin: "16px 0 0",
      isCursorPointer: true,
      alignItems: "center",
      gap: "4px",
      handleClick: gotoHome,
      "data-test-id": "ManageInsurance-FlexComp",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.AnchorTag, {
        textTransform: "uppercase",
        fontSize: "xs",
        fontWeight: "black",
        color: "var(--tm-accent-color)",
        "data-test-id": "ManageInsurance-AnchorTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FormattedText, {
          value: goHomeText,
          "data-test-id": "ManageInsurance-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ImageComponent, {
        width: "16px",
        height: "16px",
        src: goHomeBtnIcon,
        "data-test-id": "ManageInsurance-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ManageInsurance);

/***/ }),

/***/ 16160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _ManageInsurance_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94782);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const ManageInsuranceShimmer = ({}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ManageInsurance_style__WEBPACK_IMPORTED_MODULE_2__/* .ManageInsuranceStyleShimmer */ .jP, {
    "data-test-id": "ManageInsuranceShimmer-ManageInsuranceStyleShimmer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion3, {
      margin: "auto 0 0",
      height: "44px",
      width: "100%",
      "data-test-id": "ManageInsuranceShimmer-ShimmerVersion3"
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ManageInsuranceShimmer);

/***/ }),

/***/ 27481:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2324);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70827);
/* harmony import */ var remark_gfm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25284);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const MarkdownText = ({
  value
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    "data-test-id": "MarkdownText",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      remarkPlugins: [remark_gfm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z],
      rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z],
      "data-test-id": "MarkdownText-ReactMarkdown",
      children: value
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MarkdownText);

/***/ }),

/***/ 44808:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Modal_EducationHighlights)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationHighlights.style.ts


const ModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__ModalContainer",
  componentId: "sc-100il8c-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;position:relative;justify-content:center;@media (min-width:768px){background:linear-gradient(180deg,#7daff0 0%,#fefefe 100%);background-size:cover;background-position:center;background-repeat:no-repeat;height:500px;}@media (max-width:768px){height:600px;}"]);
const ImageTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__ImageTitleContainer",
  componentId: "sc-100il8c-1"
})(["@media (max-width:768px){background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/splash_primary_bg_3x_94eb4395f7.png\");background-size:cover;background-position:center;background-repeat:no-repeat;padding:200px 16px 0 16px;}width:100%;padding:16px 16px 0 16px;"]);
const CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__CloseButton",
  componentId: "sc-100il8c-2"
})(["position:absolute;top:16px;right:16px;cursor:pointer;"]);
const Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__Title",
  componentId: "sc-100il8c-3"
})(["width:100%;height:auto;font-size:32px;font-weight:700;margin-top:16px;color:", ";text-align:center;"], Global/* theme.blackText */.rS.blackText);
const Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__Description",
  componentId: "sc-100il8c-4"
})(["font-size:18px;font-weight:500;width:100%;height:auto;margin-top:12px;color:", ";text-align:center;line-height:100%;padding:0 16px;"], Global/* theme.blackText */.rS.blackText);
const AdditionalInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__AdditionalInfo",
  componentId: "sc-100il8c-5"
})(["width:100%;height:auto;font-size:16px;margin-top:18px;color:#4a4a4a;text-align:center;line-height:100%;padding:0 16px;"]);
const ModalButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationHighlightsstyle__ModalButtonsContainer",
  componentId: "sc-100il8c-6"
})(["display:flex;justify-content:space-between;margin-top:24px;width:100%;gap:16px;"]);
const ModalButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "EducationHighlightsstyle__ModalButton",
  componentId: "sc-100il8c-7"
})(["padding:10px 24px;border-radius:4px;font-weight:600;font-size:14px;cursor:pointer;flex:1;transition:all 0.3s ease;", " &:hover{opacity:0.9;}&:focus{outline:none;box-shadow:0 0 0 2px rgba(0,140,255,0.3);}"], ({
  isSecondary,
  bgColors
}) => isSecondary ? `
        background-color: ${bgColors[0] || "#FFFFFF"};
        color: #008CFF;
        border: 1px solid #008CFF;
      ` : `
        background: ${bgColors.length > 1 ? `linear-gradient(to right, ${bgColors.join(", ")})` : bgColors[0] || "#53B2FE"};
        color: #FFFFFF;
        border: none;
      `);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationHighlights.tsx







const EducationHighlights = props => {
  const {
    backendData
  } = props;
  const data = backendData?.data;
  const imageUrl = data?.image?.url || "";
  const imageWidth = data?.image?.width ? `${data.image.width}px` : "120px";
  const imageHeight = data?.image?.height ? `${data.image.height}px` : "120px";
  const title = data?.title?.text.value || "";
  const description = data?.subTitle?.text.value || "";
  const additionalInfo = data?.info?.text.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalContainer, {
    "data-test-id": "EducationHighlights-ModalContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageTitleContainer, {
      "data-test-id": "EducationHighlights-ImageTitleContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        "data-test-id": "EducationHighlights-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          src: imageUrl,
          width: imageWidth,
          height: imageHeight,
          alt: "Modal illustration",
          "data-test-id": "EducationHighlights-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          "data-test-id": "EducationHighlights-Title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
            value: title,
            "data-test-id": "EducationHighlights-FormattedText"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      "data-test-id": "EducationHighlights-Description",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
        value: description,
        "data-test-id": "EducationHighlights-FormattedText"
      })
    }), additionalInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(AdditionalInfo, {
      "data-test-id": "EducationHighlights-AdditionalInfo",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
        value: additionalInfo,
        "data-test-id": "EducationHighlights-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const Modal_EducationHighlights = (EducationHighlights);

/***/ }),

/***/ 29462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Modal_EducationProcess)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var static_components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationProcess.style.ts


const ModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__ModalContainer",
  componentId: "sc-1dnqur9-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;height:500px;position:relative;background:linear-gradient(180deg,#7daff0 0%,#fefefe 100%);background-size:contain;background-repeat:repeat;@media (max-width:768px){height:600px;}"]);
const HowItWorksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__HowItWorksContainer",
  componentId: "sc-1dnqur9-1"
})(["width:100%;display:flex;flex-direction:column;align-items:center;"]);
const SectionHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionHeading",
  componentId: "sc-1dnqur9-2"
})(["font-size:32px;font-weight:700;color:", ";line-height:100%;text-align:center;width:100%;padding:50px 0 40px;"], Global/* theme.blackText */.rS.blackText);
const SectionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionsContainer",
  componentId: "sc-1dnqur9-3"
})(["height:100%;display:flex;flex-direction:column;width:100%;gap:18px;padding:0 20px;"]);
const Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__Separator",
  componentId: "sc-1dnqur9-4"
})(["height:2px;background-color:#f0f0f0;margin-top:16px;max-width:100%;"]);
const SectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionWrapper",
  componentId: "sc-1dnqur9-5"
})([""]);
const Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__Section",
  componentId: "sc-1dnqur9-6"
})(["display:flex;flex-direction:", ";align-items:", ";gap:10px;width:100%;"], props => props.isEven ? "row" : "row-reverse", props => props.allignment);
const SectionImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionImage",
  componentId: "sc-1dnqur9-7"
})(["flex:0 0 auto;display:flex;justify-content:center;align-items:center;"]);
const SectionTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionTag",
  componentId: "sc-1dnqur9-8"
})(["display:inline-block;padding:4px 12px;border-radius:100px;background-color:white;margin-bottom:8px;background-color:", ";"], props => props.bgColors[0] || "#000000");
const SectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionContent",
  componentId: "sc-1dnqur9-9"
})(["width:100%;height:100%;flex:1;"]);
const SectionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationProcessstyle__SectionText",
  componentId: "sc-1dnqur9-10"
})(["font-size:16px;line-height:100%;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/Modal/EducationProcess.tsx






const EducationProcess = ({
  backendData,
  allignment
}) => {
  const data = backendData?.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ModalContainer, {
    "data-test-id": "EducationProcess-ModalContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HowItWorksContainer, {
      "data-test-id": "EducationProcess-HowItWorksContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionHeading, {
        "data-test-id": "EducationProcess-SectionHeading",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
          value: data?.heading,
          "data-test-id": "EducationProcess-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionsContainer, {
        "data-test-id": "EducationProcess-SectionsContainer",
        children: data.sections?.map((section, index) => {
          const isEven = index % 2 === 0;
          const isLastSection = index === (data.sections?.length ?? 0) - 1;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionWrapper, {
            "data-test-id": "EducationProcess-SectionWrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
              isEven: isEven,
              allignment: allignment || "center",
              "data-test-id": `EducationProcess-Section-${index}`,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionImage, {
                "data-test-id": "EducationProcess-SectionImage",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                  src: section.image?.url,
                  width: `${section.image?.width}px`,
                  height: `${section.image?.height}px`,
                  alt: `Step ${index + 1}`,
                  "data-test-id": "EducationProcess-ImageComponent"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionContent, {
                "data-test-id": "EducationProcess-SectionContent",
                children: [section.tag && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTag, {
                  bgColors: section.tag.styles?.bgColors || ["#000000"],
                  "data-test-id": "EducationProcess-SectionTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
                    value: section.tag.title,
                    "data-test-id": "EducationProcess-FormattedText"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionText, {
                  "data-test-id": "EducationProcess-SectionText",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components/* FormattedText */.rc, {
                    value: section.title,
                    "data-test-id": "EducationProcess-FormattedText"
                  })
                })]
              })]
            }, index), !isLastSection && /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
              "data-test-id": "EducationProcess-Separator"
            })]
          });
        })
      })]
    })
  });
};

/* harmony default export */ const Modal_EducationProcess = (EducationProcess);

/***/ }),

/***/ 38949:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": () => (/* binding */ ModalWrapper)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ReactPortalComp.tsx
var ReactPortalComp = __webpack_require__(70629);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalWrapper/ModalWrapper.style.ts

const ModalWrapperOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ModalWrapperstyle__ModalWrapperOverlay",
  componentId: "gy79ih-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:1000;padding:20px;margin:0;"]);
const ModalWrapperContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ModalWrapperstyle__ModalWrapperContainer",
  componentId: "gy79ih-1"
})(["background:#ffffff;border-radius:16px;width:", ";position:relative;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,0.12);"], props => props.customWidth);
const ModalWrapperCloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ModalWrapperstyle__ModalWrapperCloseButton",
  componentId: "gy79ih-2"
})(["position:absolute;top:8px;right:8px;cursor:pointer;z-index:10;background:none;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ModalWrapper/ModalWrapper.tsx






const ModalWrapper = ({
  isOpen,
  onClose,
  children,
  customWidth = "500px"
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPortalComp/* default */.Z, {
    "data-test-id": "ModalWrapper-ReactPortalComp",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWrapperOverlay, {
      onClick: handleOverlayClick,
      "data-test-id": "ModalWrapper-ModalWrapperOverlay",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalWrapperContainer, {
        customWidth: customWidth,
        "data-test-id": "ModalWrapper-ModalWrapperContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalWrapperCloseButton, {
          onClick: onClose,
          "data-test-id": "ModalWrapper-ModalWrapperCloseButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            width: "20px",
            height: "20px",
            alt: "Close",
            "data-test-id": "ModalWrapper-ImageComponent"
          })
        }), children]
      })
    })
  });
};
/* harmony default export */ const ModalWrapper_ModalWrapper = ((/* unused pure expression or super */ null && (ModalWrapper)));

/***/ }),

/***/ 88410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": () => (/* binding */ MyPartnerInsuranceHeader)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87109);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44928);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48359);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';






const DynamicMMTHeader = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(() => Promise.all(/* import() */[__webpack_require__.e(8611), __webpack_require__.e(9681), __webpack_require__.e(1597), __webpack_require__.e(500), __webpack_require__.e(1285), __webpack_require__.e(2346), __webpack_require__.e(1516), __webpack_require__.e(7556), __webpack_require__.e(454), __webpack_require__.e(5802), __webpack_require__.e(3007), __webpack_require__.e(1359), __webpack_require__.e(3025), __webpack_require__.e(4775), __webpack_require__.e(98), __webpack_require__.e(6966), __webpack_require__.e(3633), __webpack_require__.e(437), __webpack_require__.e(9579), __webpack_require__.e(8584), __webpack_require__.e(3511), __webpack_require__.e(4891), __webpack_require__.e(6723), __webpack_require__.e(4044), __webpack_require__.e(7991), __webpack_require__.e(1935), __webpack_require__.e(8469), __webpack_require__.e(7512), __webpack_require__.e(3831), __webpack_require__.e(2148), __webpack_require__.e(8991), __webpack_require__.e(3365), __webpack_require__.e(6707), __webpack_require__.e(3437), __webpack_require__.e(4015), __webpack_require__.e(8187), __webpack_require__.e(6793), __webpack_require__.e(4657), __webpack_require__.e(5726)]).then(__webpack_require__.t.bind(__webpack_require__, 18972, 23)).then(module => module.Header), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(18972)]
  }
});
function MyPartnerInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  isMyBiz,
  exitWebViewOnBack = false
}) {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();

  let headerPropsWithDefaults = _objectSpread({
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    onLogin: () => next_router__WEBPACK_IMPORTED_MODULE_4___default().reload(),
    onLoginFlowComplete: () => void 0,
    onModalChange: () => void 0,
    showMoreButton: false,
    showLoginPersuasionSlider: false,
    pokusExperiments: {
      mypStandaloneInsurance: true,
      mypartnerMima: true,
      mypVisaCommon: false,
      mypHolidaysCommon: false
    },
    multiLingualData: {
      "header.login.signup.for.best.prices": "Please login to purchase your travel insurance",
      "header.promotional.discount": "Promo Cash",
      "header.new.custom.tag": "No KYC"
    },
    myPartner: true,
    globalConfig: null,
    headerCommonData: {
      loyaltyHeaderData: null,
      walletHeaderData: null,
      mobileCore: null,
      userInfoData: null
    }
  }, headerProps);

  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }

  if (headerPropsWithDefaults?.forceLogin) {
    headerPropsWithDefaults = _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      activeModal: "LOGIN"
    });
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
      "data-test-id": "DynamicMMTHeader"
    }));
  }

  return isMyBiz && device === "lg" ? null : device === "lg" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicMMTHeader, _objectSpread(_objectSpread({}, headerPropsWithDefaults), {}, {
    "data-test-id": "DynamicMMTHeader"
  })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(___WEBPACK_IMPORTED_MODULE_5__.LandingHeaderMobile, {
    headerTitle: mobileTitle,
    myOrders: myOrders,
    goToMyOrders: goToMyOrders,
    displayWhiteHeader: displayWhiteHeader,
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_2__.PARTNER.MMT,
    insuranceHeader: true,
    exitWebViewOnBack: exitWebViewOnBack,
    "data-test-id": "LandingHeaderMobile"
  });
}

/***/ }),

/***/ 5173:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ NoInsurancePlan_NoInsurancePlan)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.style.ts

const NoInsurancePlanStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NoInsurancePlanstyle__NoInsurancePlanStyle",
  componentId: "qwiuqk-0"
})(["background:#ffffff;box-shadow:0px 3px 30px rgba(0,0,0,0.16);border-radius:16px;padding:32px;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.tsx









const NoInsurancePlan = ({
  title,
  info
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(NoInsurancePlanStyle, {
    "data-test-id": "NoInsurancePlan-NoInsurancePlanStyle",
    children: ["\xA0\xA0", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
      width: "80px",
      height: "80px",
      src: "https://tripmoneycmsimgak.mmtcdn.com/img/No_Ins_Icon_55794fe5f5.svg",
      "data-test-id": "NoInsurancePlan-ImageComponent"
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      margin: device == "lg" ? "24px 0 8px" : "32px 0 32px",
      fontSize: "large",
      fontWeight: "bold",
      color: Global/* theme.blackText */.rS.blackText,
      "data-test-id": "NoInsurancePlan-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "NoInsurancePlan-FormattedText"
      })
    }), info && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "sm",
      color: Global/* theme.greyText7 */.rS.greyText7,
      "data-test-id": "NoInsurancePlan-ParaTag",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: info,
        "data-test-id": "NoInsurancePlan-FormattedText"
      })
    })]
  });
};

/* harmony default export */ const NoInsurancePlan_NoInsurancePlan = (NoInsurancePlan);

/***/ }),

/***/ 58487:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OfferedBySection_OfferedBySection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OfferedBySection/OfferedBySection.style.ts

const OfferedByContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OfferedBySectionstyle__OfferedByContainer",
  componentId: "sc-14tj0vx-0"
})(["padding:16px;width:fit-content;display:flex;align-items:center;background:#00000066;border-radius:8px;gap:8px;"]);
const OfferedByTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OfferedBySectionstyle__OfferedByTitle",
  componentId: "sc-14tj0vx-1"
})(["font-size:14px;color:#ffffff;"]);
const OfferedByValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OfferedBySectionstyle__OfferedByValue",
  componentId: "sc-14tj0vx-2"
})(["font-size:12px;font-weight:700;color:#ffffff;margin-bottom:12px;text-align:right;width:100%;"]);
const OfferedByIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OfferedBySectionstyle__OfferedByIconContainer",
  componentId: "sc-14tj0vx-3"
})(["display:flex;gap:8px;justify-content:center;align-items:center;> * + *{border-left:1px solid #979797;padding-left:12px;}"]);
const OfferedByIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "OfferedBySectionstyle__OfferedByIcon",
  componentId: "sc-14tj0vx-4"
})(["height:32px;width:auto;max-width:60px;object-fit:contain;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OfferedBySection/OfferedBySection.tsx








const OfferedBySection = ({
  data
}) => {
  const {
    title,
    description,
    icons
  } = data;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "offered_by_section_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: offeredBySectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OfferedByContainer, {
    ref: offeredBySectionRef,
    "data-test-id": "OfferedBySection-OfferedByContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OfferedByTitle, {
      "data-test-id": "OfferedBySection-OfferedByTitle",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "OfferedBySection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OfferedByIconContainer, {
      "data-test-id": "OfferedBySection-OfferedByIconContainer",
      children: icons?.map((iconUrl, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(OfferedByIcon, {
        src: iconUrl,
        alt: `Insurance Provider ${index + 1}`,
        "data-test-id": `OfferedBySection-OfferedByIcon-${index}`
      }, index))
    })]
  });
};

/* harmony default export */ const OfferedBySection_OfferedBySection = (OfferedBySection);

/***/ }),

/***/ 22637:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OffersBenefitsSection_OffersBenefitsSection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/components/index.tsx + 65 modules
var components = __webpack_require__(54927);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OffersBenefitsSection/OffersBenefitsSection.style.ts


const OffersBenefitsSectionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionContainer",
  componentId: "sc-1cybc7d-0"
})(["display:flex;flex-direction:column;gap:32px;width:1200px;border-radius:16px;padding:40px;margin:0 auto;background:linear-gradient( 251.57deg,#5483bc 0%,#ffffff 19.31%,#e3ebf4 27.82%,#ffffff 45.19% );"]);
const OffersBenefitsSectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionTitle",
  componentId: "sc-1cybc7d-1"
})(["color:", ";font-weight:900;font-size:32px;"], Global/* theme.blackText */.rS.blackText);
const OffersBenefitsSectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionDescription",
  componentId: "sc-1cybc7d-2"
})(["font-size:16px;font-weight:400;color:", ";width:80%;"], Global/* theme.greyText */.rS.greyText);
const OffersBenefitsSectionCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCards",
  componentId: "sc-1cybc7d-3"
})(["display:flex;align-items:center;justify-content:space-between;gap:16px;height:auto;"]);
const OffersBenefitsSectionCardBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardBadge",
  componentId: "sc-1cybc7d-4"
})(["padding:2px 8px;border-radius:100px;background:linear-gradient(90deg,", ");font-weight:900;font-size:12px;color:", ";position:absolute;top:0;left:0;transform:translateY(-50%) translateX(33%);"], props => props.bgGradient.join(","), Global/* theme.whiteText */.rS.whiteText);
const OffersBenefitsSectionCardTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardTitle",
  componentId: "sc-1cybc7d-5"
})(["font-size:24px;color:", ";font-weight:900;font-size:24px;"], Global/* theme.blackText */.rS.blackText);
const OffersBenefitsSectionCardDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardDesc",
  componentId: "sc-1cybc7d-6"
})(["font-weight:900;color:linear-gradient(225deg,#3023ae 0%,#c86dd7 100%);font-size:12px;"]);
const OffersBenefitsSectionCardBenefitImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardBenefitImg",
  componentId: "sc-1cybc7d-7"
})(["width:auto;height:81px;object-fit:cover;border-radius:16px;"]);
const OffersBenefitsSectionCardBenefitInfo = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardBenefitInfo",
  componentId: "sc-1cybc7d-8"
})(["color:", ";font-weight:400;font-size:14px;"], Global/* theme.greyText */.rS.greyText);
const OffersBenefitsSectionCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OffersBenefitsSectionstyle__OffersBenefitsSectionCardContainer",
  componentId: "sc-1cybc7d-9"
})(["display:flex;flex-direction:column;height:-webkit-fill-available;width:268px;gap:16px;border-radius:20px;padding:24px;border:1px solid #d8d8d8;background:", ";position:relative;"], Global/* theme.whiteText */.rS.whiteText);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OffersBenefitsSection/OffersBenefitsSection.tsx








const OffersBenefitsSection = ({
  data
}) => {
  const {
    title,
    description,
    cards
  } = data;
  if (!data) return null;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "offers_benefits_section_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: offersBenefitsSectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });

  const OffersBenefitsSectionCard = ({
    key,
    card
  }) => {
    const {
      title,
      badge,
      image,
      description,
      benefitInfo
    } = card;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(OffersBenefitsSectionCardContainer, {
      "data-test-id": `OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardContainer-${key}`,
      children: [badge && /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCardBadge, {
        bgGradient: badge.bgGradient,
        "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardBadge",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: badge.title,
          "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCardTitle, {
        "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: title,
          "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCardDesc, {
        "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardDesc",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: description,
          "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCardBenefitImg, {
        src: image,
        "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardBenefitImg"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCardBenefitInfo, {
        "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-OffersBenefitsSectionCardBenefitInfo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
          value: benefitInfo,
          "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCard-FormattedText"
        })
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OffersBenefitsSectionContainer, {
    ref: offersBenefitsSectionRef,
    "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionTitle, {
      "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionTitle",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: title,
        "data-test-id": "OffersBenefitsSection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionDescription, {
      "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionDescription",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* FormattedText */.rc, {
        value: description,
        "data-test-id": "OffersBenefitsSection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCards, {
      "data-test-id": "OffersBenefitsSection-OffersBenefitsSectionCards",
      children: cards.map((card, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(OffersBenefitsSectionCard, {
        card: card,
        "data-test-id": `OffersBenefitsSection-OffersBenefitsSectionCard-${index}`
      }, index))
    })]
  });
};

/* harmony default export */ const OffersBenefitsSection_OffersBenefitsSection = (OffersBenefitsSection);

/***/ }),

/***/ 22382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": () => (/* binding */ PlanDetailStyle),
/* harmony export */   "Rf": () => (/* binding */ OrderDetailCompStyle),
/* harmony export */   "du": () => (/* binding */ OrderDetailsItem),
/* harmony export */   "ew": () => (/* binding */ TravellerItem),
/* harmony export */   "kD": () => (/* binding */ OrderDetailsTable),
/* harmony export */   "pl": () => (/* binding */ OrderDetailTravellerStyle),
/* harmony export */   "q7": () => (/* binding */ OrderMobCtaWrap)
/* harmony export */ });
/* unused harmony exports PlanDetailsInfo, OrderMobAmtWrap */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88025);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84576);



const OrderDetailCompStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailCompStyle",
  componentId: "hdko8w-0"
})(["background:#ffffff;border-radius:16px;padding:20px;picture{display:inherit;flex-shrink:0;}@media ", "{padding:16px 16px 12px;border-radius:0px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const OrderDetailTravellerStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailTravellerStyle",
  componentId: "hdko8w-1"
})(["border:1px solid #e2e2e2;@media ", "{border:none;padding-left:24px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const TravellerItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l).withConfig({
  displayName: "OrderDetailCompstyle__TravellerItem",
  componentId: "hdko8w-2"
})(["border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-bottom:none;}@media ", "{padding:8px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const PlanDetailStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailStyle",
  componentId: "hdko8w-3"
})(["background:#f6faff;border-radius:8px;padding:16px;@media ", "{background:transparent;padding:0;min-height:100%;padding-left:32px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const PlanDetailsInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__PlanDetailsInfo",
  componentId: "hdko8w-4"
})(["background:#ffffff;margin-top:16px;display:grid;grid-template-columns:2fr 2fr 2fr 0.6fr;", "{border-right:1px solid #e8e8e8;padding:12px 16px;:last-child{border:none;}}@media ", "{display:flex;flex-direction:column;", "{border:none;border-bottom:1px solid #e8e8e8;padding:12px 0 12px 0px;}", ":last-child{border:none;}}"], _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile, _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l, _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l);
const OrderDetailsTable = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsTable",
  componentId: "hdko8w-5"
})(["display:grid;grid-template-columns:repeat(3,1fr);border:1px solid #e8e8e8;", "{:nth-child(n + 3){border-bottom:none;}:nth-child(3){border-right:none;border-bottom:1px solid #e8e8e8;}}@media ", "{display:flex;flex-direction:column;border:none;", "{border-bottom:1px solid #e8e8e8;padding:12px 0;border-right:none;:nth-child(n + 3){border-bottom:1px solid #e8e8e8;}:last-child{border-bottom:none;}}}"], _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l, _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile, _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l);
const OrderDetailsItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l).withConfig({
  displayName: "OrderDetailCompstyle__OrderDetailsItem",
  componentId: "hdko8w-6"
})(["border-right:1px solid #e2e2e2;border-bottom:1px solid #e2e2e2;padding:12px 16px;:last-child{border-right:none;}@media ", "{display:flex;justify-content:space-between;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_2__/* .deviceType.mobile */ .vO.mobile);
const OrderMobCtaWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobCtaWrap",
  componentId: "hdko8w-7"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px 20px 16px 48px;background:#fff;border:1px solid rgba(232,232,232,1);box-shadow:0px 1px 4px 0px rgba(74,74,74,0.2);"]);
const OrderMobAmtWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailCompstyle__OrderMobAmtWrap",
  componentId: "hdko8w-8"
})(["display:flex;align-items:center;justify-content:space-between;padding:16px;background:#fff;border:1px solid rgba(232,232,232,1);"]);

/***/ }),

/***/ 23558:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87109);
/* harmony import */ var _OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const OrderDetailInsurance = ({
  insPlanName,
  orderDetailIcon,
  orderDetails,
  insuranceType,
  insuranceInfo,
  insuranceTypeColor,
  forInsuranceContainer,
  handleClickInsurance
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .OrderDetailCompStyle */ .Rf, {
    "data-test-id": "OrderDetailInsurance-OrderDetailCompStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      flexDirection: device == "lg" ? "row" : "row-reverse",
      justifyContent: device == "lg" ? "" : "space-between",
      alignItems: device == "lg" ? "" : "center",
      margin: device == "lg" ? "0 0 24px" : "0 0 14px",
      gap: "8px",
      "data-test-id": "OrderDetailInsurance-FlexComp",
      children: [orderDetailIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
        width: "56px",
        height: "56px",
        src: orderDetailIcon,
        "data-test-id": "OrderDetailInsurance-ImageComponent"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        flexDirection: "column",
        gap: "2px",
        margin: "0",
        "data-test-id": "OrderDetailInsurance-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "large" : "md",
          fontWeight: "bold",
          "data-test-id": "OrderDetailInsurance-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
            value: insPlanName,
            "data-test-id": "OrderDetailInsurance-FormattedText"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
          "data-test-id": "OrderDetailInsurance-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
            value: insuranceInfo,
            "data-test-id": "OrderDetailInsurance-FormattedText"
          })
        })]
      }), device == "lg" && insuranceType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontSize: "xs",
        fontWeight: "bold",
        textTransform: "uppercase",
        margin: "0 0 0 auto",
        color: insuranceTypeColor,
        "data-test-id": "OrderDetailInsurance-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: insuranceType,
          "data-test-id": "OrderDetailInsurance-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .OrderDetailsTable */ .kD, {
      "data-test-id": "OrderDetailInsurance-OrderDetailsTable",
      children: orderDetails?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .OrderDetailsItem */ .du, {
          gap: "16px",
          "data-test-id": `OrderDetailInsurance-OrderDetailsItem-${index}`,
          children: [item.label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
            textTransform: "uppercase",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText7 */ .rS.greyText7,
            fontSize: "xs",
            "data-test-id": "OrderDetailInsurance-ParaTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
              value: item.label,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: "xs",
            fontWeight: "bold",
            "data-test-id": "OrderDetailInsurance-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
              value: item.value,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          })]
        }, index);
      })
    }), device == "sm" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      gap: "35px",
      borderTop: "1px solid #e2e2e2",
      margin: "16px -16px 0",
      padding: "16px 16px 0",
      justifyContent: "space-between",
      "data-test-id": "OrderDetailInsurance-FlexComp",
      children: forInsuranceContainer?.forInsurance?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          flex: "1",
          flexDirection: "column",
          alignItems: "center",
          gap: "6px",
          handleClick: () => handleClickInsurance(item),
          "data-test-id": `OrderDetailInsurance-FlexComp-${index}`,
          children: [item.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
            width: "36px",
            height: "36px",
            src: item.icon,
            "data-test-id": "OrderDetailInsurance-ImageComponent"
          }), item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
            fontSize: "xs",
            "data-test-id": "OrderDetailInsurance-AnchorTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
              value: item.title,
              "data-test-id": "OrderDetailInsurance-FormattedText"
            })
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetailInsurance);

/***/ }),

/***/ 99180:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87109);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const OrderDetailPlan = ({
  title,
  orderDetailIcon,
  planBenefits,
  handleMoreBenefits,
  ctaLink,
  subTitle,
  benefitsCTA
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    "data-test-id": "OrderDetailPlan",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .OrderDetailCompStyle */ .Rf, {
      "data-test-id": "OrderDetailPlan-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "OrderDetailPlan-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "OrderDetailPlan-ImageComponent"
        }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText,
          "data-test-id": "OrderDetailPlan-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.FormattedText, {
            value: title,
            "data-test-id": "OrderDetailPlan-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .PlanDetailStyle */ .BP, {
        "data-test-id": "OrderDetailPlan-PlanDetailStyle",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_3__.ParaTag, {
          fontWeight: "bold",
          fontSize: "large",
          "data-test-id": "OrderDetailPlan-ParaTag",
          children: subTitle
        })
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetailPlan);

/***/ }),

/***/ 22026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const OrderDetailPlanShimmer = () => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailCompStyle */ .Rf, {
    "data-test-id": "OrderDetailPlanShimmer-OrderDetailCompStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion2, {
      width: "366px",
      height: "25px",
      margin: "0 0 24px",
      "data-test-id": "OrderDetailPlanShimmer-ShimmerVersion2"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_2__/* .PlanDetailStyle */ .BP, {
      "data-test-id": "OrderDetailPlanShimmer-PlanDetailStyle"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetailPlanShimmer);

/***/ }),

/***/ 40455:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44928);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42874);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50354);
/* harmony import */ var _OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();

const OrderDetailTraveller = ({
  title,
  orderDetailIcon,
  travellerDetails,
  editEnabled,
  editTraveller,
  updateOrderDetails,
  handleClickEditDetailSheet
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointV2 */ .bU)();
  const {
    0: editTravellerIndex,
    1: setEditTravellerIndex
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1);
  const {
    0: travellerData,
    1: setTravellerData
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (travellerDetails) {
      setTravellerData(travellerDetails);
    }
  }, [travellerDetails]);

  const handleClickEditDetails = index => {
    setEditTravellerIndex(index);
  };

  const handleUpdateDetails = async (updatedData, index) => {
    const travellers = [...travellerData];
    travellers[index] = _objectSpread(_objectSpread({}, travellers[index]), updatedData);
    setTravellerData(travellers);
    await updateOrderDetails?.();
    setEditTravellerIndex(-1);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    "data-test-id": "OrderDetailTraveller",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_9__/* .OrderDetailCompStyle */ .Rf, {
      "data-test-id": "OrderDetailTraveller-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "OrderDetailTraveller-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "OrderDetailTraveller-ImageComponent"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__/* .theme.greyText */ .rS.greyText,
          "data-test-id": "OrderDetailTraveller-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FormattedText, {
            value: title,
            "data-test-id": "OrderDetailTraveller-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_9__/* .OrderDetailTravellerStyle */ .pl, {
        "data-test-id": "OrderDetailTraveller-OrderDetailTravellerStyle",
        children: travellerData?.map((item, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_9__/* .TravellerItem */ .ew, {
            alignItems: "baseline",
            justifyContent: "space-between",
            "data-test-id": `OrderDetailTraveller-TravellerItem-${index}`,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FlexComp, {
              gap: "4px",
              flexDirection: "column",
              "data-test-id": `OrderDetailTraveller-FlexComp-${index}`,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.ParaTag, {
                fontSize: device == "lg" ? "md" : "sm",
                fontWeight: "bold",
                "data-test-id": "OrderDetailTraveller-ParaTag",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FormattedText, {
                  value: item.name,
                  "data-test-id": "OrderDetailTraveller-FormattedText"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                children: [item?.dob && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__/* .theme.greyText */ .rS.greyText,
                  "data-test-id": "OrderDetailTraveller-SpanTag",
                  children: ["\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FormattedText, {
                    value: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(item.dob, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__.DATE_FORMATS["DD/MM/YYYY"]),
                    "data-test-id": "OrderDetailTraveller-FormattedText"
                  }), " ", "|"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.SpanTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_7__/* .theme.greyText */ .rS.greyText,
                  "data-test-id": "OrderDetailTraveller-SpanTag",
                  children: ["\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FormattedText, {
                    value: item.gender,
                    "data-test-id": "OrderDetailTraveller-FormattedText"
                  })]
                })]
              })]
            }, index), device == "lg" && editEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.AnchorTag, {
              handleClick: () => {
                analytics?.trackOrderDetailsEvents({
                  actionType: "edit_details_clicked"
                } //"click"
                );
                (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_8__.trackEvent)({
                  event_detail: {
                    event_type: "action",
                    event_name: "component_cta-clicked",
                    event_value: "edit_details_clicked"
                  }
                });
                handleClickEditDetails(index);
              },
              "data-test-id": "OrderDetailTraveller-AnchorTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.ImageComponent, {
                width: "16px",
                height: "16px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Edit_Icon_9bd6098b75.svg",
                "data-test-id": "OrderDetailTraveller-ImageComponent"
              })
            }), editTravellerIndex === index && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.EditTraveller, {
              index: index,
              title: editTraveller?.title,
              travellerDetails: travellerData,
              travellerAttributes: editTraveller?.travellerAttributes,
              fullName: item.name,
              dobValue: item.dob,
              passportValue: item.passport,
              genderValue: item.gender,
              refId: item.refId,
              goBackTxt: editTraveller?.goBackBtnTxt,
              updateContactTxt: editTraveller?.updateNowBtnTxt,
              handleUpdateDetails: updatedData => handleUpdateDetails(updatedData, index),
              handleClose: () => setEditTravellerIndex(-1),
              "data-test-id": "OrderDetailTraveller-EditTraveller"
            })]
          }, index);
        })
      })]
    }), device == "sm" && editEnabled && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_9__/* .OrderMobCtaWrap */ .q7, {
      onClick: handleClickEditDetailSheet,
      "data-test-id": "OrderDetailTraveller-OrderMobCtaWrap",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.AnchorTag, {
        fontWeight: "bold",
        "data-test-id": "OrderDetailTraveller-AnchorTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.FormattedText, {
          value: "Edit Traveller Details",
          "data-test-id": "OrderDetailTraveller-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_5__.ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg",
        "data-test-id": "OrderDetailTraveller-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetailTraveller);

/***/ }),

/***/ 28693:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87109);
/* harmony import */ var _OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const PrimaryContact = ({
  title,
  orderDetailIcon,
  contactDetails,
  handleAlternateContact
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_3__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    "data-test-id": "PrimaryContact",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailComp_style__WEBPACK_IMPORTED_MODULE_4__/* .OrderDetailCompStyle */ .Rf, {
      "data-test-id": "PrimaryContact-OrderDetailCompStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        alignItems: "center",
        margin: device == "lg" ? "0 0 24px" : "0 0 16px",
        gap: "8px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: [orderDetailIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
          width: "24px",
          height: "24px",
          src: orderDetailIcon,
          "data-test-id": "PrimaryContact-ImageComponent"
        }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "bold",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
          "data-test-id": "PrimaryContact-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
            value: title,
            "data-test-id": "PrimaryContact-FormattedText"
          })
        })]
      }), contactDetails?.name && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
        margin: "0 0 10px 32px",
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "PrimaryContact-ParaTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: contactDetails?.name,
          "data-test-id": "PrimaryContact-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        margin: "0 0 10px",
        alignItems: "center",
        gap: "6px",
        padding: "0 0 0 32px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
          width: "16px",
          height: "16px",
          src: "https://tripmoneycmsimgak.mmtcdn.com/img/mail_Icon_cf3395e217.svg",
          "data-test-id": "PrimaryContact-ImageComponent"
        }), contactDetails?.email && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
          "data-test-id": "PrimaryContact-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
            value: contactDetails?.email,
            "data-test-id": "PrimaryContact-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        justifyContent: "space-between",
        padding: "0 0 0 32px",
        "data-test-id": "PrimaryContact-FlexComp",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          alignItems: "center",
          gap: "6px",
          "data-test-id": "PrimaryContact-FlexComp",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
            width: "16px",
            height: "16px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/call_Icon_94b21de941.svg",
            "data-test-id": "PrimaryContact-ImageComponent"
          }), contactDetails?.contactNo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: device == "lg" ? "sm" : "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
            "data-test-id": "PrimaryContact-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
              value: contactDetails?.contactNo,
              "data-test-id": "PrimaryContact-FormattedText"
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PrimaryContact);

/***/ }),

/***/ 71527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61874);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17871);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const OrderAmtPaid = ({
  title,
  info,
  handleInvoice,
  amountPaid
}) => {
  const {
    breakupTxt,
    details
  } = amountPaid ?? {};
  const {
    bank,
    accNo,
    amt
  } = details ?? {};
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightStyle */ .oU, {
    "data-test-id": "OrderAmtPaid-OrderRightStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightHd */ .M9, {
      "data-test-id": "OrderAmtPaid-OrderRightHd",
      children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderAmtPaid-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          value: title,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      }), info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderAmtPaid-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          value: info,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightCntnt */ .X, {
      "data-test-id": "OrderAmtPaid-OrderRightCntnt",
      children: [breakupTxt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "OrderAmtPaid-ParaTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          value: breakupTxt,
          "data-test-id": "OrderAmtPaid-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        justifyContent: "space-between",
        margin: "8px 0 16px",
        "data-test-id": "OrderAmtPaid-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          flexDirection: "column",
          margin: "unset",
          "data-test-id": "OrderAmtPaid-FlexComp",
          children: [bank && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
            fontSize: "xs",
            "data-test-id": "OrderAmtPaid-ParaTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              value: bank,
              "data-test-id": "OrderAmtPaid-FormattedText"
            })
          }), accNo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: "xs",
            "data-test-id": "OrderAmtPaid-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              value: accNo,
              "data-test-id": "OrderAmtPaid-FormattedText"
            })
          })]
        }), amt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: "xs",
          "data-test-id": "OrderAmtPaid-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: amt,
            "data-test-id": "OrderAmtPaid-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.LandingButtonWhite, {
        customWidth: "100%",
        customTitle: "DOWNLOAD INVOICE",
        onClick: handleInvoice,
        "data-test-id": "OrderAmtPaid-LandingButtonWhite"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderAmtPaid);

/***/ }),

/***/ 61874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M9": () => (/* binding */ OrderRightHd),
/* harmony export */   "Tv": () => (/* binding */ MmtServiceFee),
/* harmony export */   "X": () => (/* binding */ OrderRightCntnt),
/* harmony export */   "Xd": () => (/* binding */ PriceText),
/* harmony export */   "oU": () => (/* binding */ OrderRightStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88025);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);



const OrderRightStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightStyle",
  componentId: "cex5w1-0"
})(["background:#ffffff;border-radius:16px;"]);
const OrderRightHd = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightHd",
  componentId: "cex5w1-1"
})(["padding:20px 20px 12px;border-bottom:1px solid #f2f2f2;display:flex;justify-content:space-between;gap:10px;"]);
const OrderRightCntnt = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailRightCompstyle__OrderRightCntnt",
  componentId: "cex5w1-2"
})(["padding:12px 20px;"]);
const PriceText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "OrderDetailRightCompstyle__PriceText",
  componentId: "cex5w1-3"
})(["flex-shrink:0;"]);
const MmtServiceFee = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l).withConfig({
  displayName: "OrderDetailRightCompstyle__MmtServiceFee",
  componentId: "cex5w1-4"
})(["margin-top:12px;padding-top:12px;margin-bottom:12px;padding-bottom:12px;border-bottom:1px solid #f2f2f2;border-top:1px solid #f2f2f2;"]);

/***/ }),

/***/ 41232:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87109);
/* harmony import */ var _OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52322);







const OrderGetHelp = ({
  title,
  info,
  getHelp
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_3__/* .OrderRightStyle */ .oU, {
    "data-test-id": "OrderGetHelp-OrderRightStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_3__/* .OrderRightHd */ .M9, {
      "data-test-id": "OrderGetHelp-OrderRightHd",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderGetHelp-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: title,
          "data-test-id": "OrderGetHelp-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderGetHelp-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: info,
          "data-test-id": "OrderGetHelp-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_3__/* .OrderRightCntnt */ .X, {
      "data-test-id": "OrderGetHelp-OrderRightCntnt",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        justifyContent: device == "lg" ? "space-between" : "center",
        gap: device == "lg" ? "20px" : "42px",
        "data-test-id": "OrderGetHelp-FlexComp",
        children: getHelp?.map((item, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
            gap: "8px",
            alignItems: "center",
            flexDirection: "column",
            "data-test-id": `OrderGetHelp-FlexComp-${index}`,
            children: [item.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
              width: "27px",
              height: "27px",
              src: item.icon,
              "data-test-id": "OrderGetHelp-ImageComponent"
            }), item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
              fontSize: "xs",
              "data-test-id": "OrderGetHelp-AnchorTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
                value: item.title,
                "data-test-id": "OrderGetHelp-FormattedText"
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderGetHelp);

/***/ }),

/***/ 79229:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const OrderInsurance = ({
  title,
  info,
  forInsurance,
  handleClickInsurance
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightStyle */ .oU, {
    "data-test-id": "OrderInsurance-OrderRightStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightHd */ .M9, {
      "data-test-id": "OrderInsurance-OrderRightHd",
      children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderInsurance-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: title,
          "data-test-id": "OrderInsurance-FormattedText"
        })
      }), info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderInsurance-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: info,
          "data-test-id": "OrderInsurance-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightCntnt */ .X, {
      "data-test-id": "OrderInsurance-OrderRightCntnt",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        flexDirection: "column",
        gap: "14px",
        "data-test-id": "OrderInsurance-FlexComp",
        children: forInsurance?.map((item, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
            alignItems: "center",
            gap: "16px",
            handleClick: () => handleClickInsurance(item),
            "data-test-id": `OrderInsurance-FlexComp-${index}`,
            children: [item.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
              width: "20px",
              height: "20px",
              src: item.icon,
              "data-test-id": "OrderInsurance-ImageComponent"
            }), item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
              fontWeight: "bold",
              "data-test-id": "OrderInsurance-AnchorTag",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
                value: item.title,
                "data-test-id": "OrderInsurance-FormattedText"
              })
            })]
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderInsurance);

/***/ }),

/***/ 84981:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61874);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17871);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52322);








const OrderPriceBreakup = ({
  title,
  info,
  priceBreakup,
  totalPrice,
  mmtServiceFee
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightStyle */ .oU, {
    "data-test-id": "OrderPriceBreakup-OrderRightStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightHd */ .M9, {
      "data-test-id": "OrderPriceBreakup-OrderRightHd",
      children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderPriceBreakup-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          value: title,
          "data-test-id": "OrderPriceBreakup-FormattedText"
        })
      }), info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "OrderPriceBreakup-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          value: info,
          "data-test-id": "OrderPriceBreakup-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderRightCntnt */ .X, {
      "data-test-id": "OrderPriceBreakup-OrderRightCntnt",
      children: [priceBreakup && priceBreakup.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          justifyContent: "space-between",
          "data-test-id": `OrderPriceBreakup-FlexComp-${index}`,
          children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText7 */ .rS.greyText7,
            "data-test-id": "OrderPriceBreakup-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              value: item.title,
              "data-test-id": "OrderPriceBreakup-FormattedText"
            })
          }), item.price && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .PriceText */ .Xd, {
            txtfontSize: "xs",
            "data-test-id": "OrderPriceBreakup-PriceText",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              value: item.price,
              "data-test-id": "OrderPriceBreakup-FormattedText"
            })
          })]
        }, index);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .MmtServiceFee */ .Tv, {
        justifyContent: "space-between",
        "data-test-id": "OrderPriceBreakup-MmtServiceFee",
        children: [mmtServiceFee?.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: "xs",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.blackText */ .rS.blackText,
          "data-test-id": "OrderPriceBreakup-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: mmtServiceFee?.title,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        }), mmtServiceFee?.price && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .PriceText */ .Xd, {
          txtfontSize: "xs",
          txtfontWeight: "bold",
          "data-test-id": "OrderPriceBreakup-PriceText",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: mmtServiceFee?.price,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        justifyContent: "space-between",
        "data-test-id": "OrderPriceBreakup-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontWeight: "bold",
          fontSize: "md",
          "data-test-id": "OrderPriceBreakup-SpanTag",
          children: "Total Price"
        }), totalPrice && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_OrderDetailRightComp_style__WEBPACK_IMPORTED_MODULE_2__/* .PriceText */ .Xd, {
          txtfontWeight: "bold",
          txtfontSize: "md",
          "data-test-id": "OrderPriceBreakup-PriceText",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: totalPrice,
            "data-test-id": "OrderPriceBreakup-FormattedText"
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderPriceBreakup);

/***/ }),

/***/ 54904:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ko": () => (/* binding */ OrderDetailsSectionOne),
/* harmony export */   "Ym": () => (/* binding */ OrderDetailsSectionTwo),
/* harmony export */   "ap": () => (/* binding */ OrderDetailsList),
/* harmony export */   "mp": () => (/* binding */ OrderDetailsStyle)
/* harmony export */ });
/* unused harmony export OrderDetailsSectionThree */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44928);


const OrderDetailsStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsStyle",
  componentId: "jnokfb-0"
})(["background:#ffffff;box-shadow:0px 1px 8px rgba(0,0,0,0.179518);border-radius:16px;overflow:hidden;margin:", ";picture,img{flex-shrink:0;}@media ", "{padding-bottom:16px;}"], props => props.margin, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_1__.deviceType.mobile);
const OrderDetailsSectionOne = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionOne",
  componentId: "jnokfb-1"
})(["padding:16px 30px;background:#fff;display:flex;align-items:center;justify-content:space-between;font-weight:700;font-size:14px;line-height:19px;text-transform:uppercase;color:#000000;"]);
const OrderDetailsSectionTwo = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionTwo",
  componentId: "jnokfb-2"
})(["padding:16px 30px;background:linear-gradient(93.36deg,#f2eae6 -17.08%,#ffffff 118.39%);display:flex;align-items:center;gap:20px;margin-bottom:8px;min-height:90px;.imgWrap{width:145px;height:88px;}"]);
const OrderDetailsSectionThree = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsSectionThree",
  componentId: "jnokfb-3"
})(["padding:16px 30px;background:#fff;display:flex;flex-direction:column;border:1px dashed #fafafa;background:#fafafa;margin:8px 0;"]);
const OrderDetailsList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "OrderDetailsstyle__OrderDetailsList",
  componentId: "jnokfb-4"
})(["border-top:1px dashed #d8d8d8;padding-top:16px;padding-bottom:2px;"]);

/***/ }),

/***/ 35311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54904);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42874);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17871);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87109);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52322);









const OrderDetails = ({
  orderDetails,
  margin,
  downloadPolicy,
  navigateToDownloadPolicy
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointV2 */ .bU)();
  const {
    planName,
    packName,
    insPackName,
    packColor,
    packImg,
    orderDetailAmt
  } = orderDetails ?? {};
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsStyle */ .mp, {
    margin: margin,
    "data-test-id": "OrderDetails-OrderDetailsStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsSectionOne */ .Ko, {
      "data-test-id": "OrderDetails-OrderDetailsSectionOne",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontWeight: "black",
        "data-test-id": "OrderDetails-SpanTag",
        children: "Plan details"
      }), insPackName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
        fontSize: "xs",
        fontWeight: "black",
        color: packColor,
        "data-test-id": "OrderDetails-SpanTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          value: insPackName,
          "data-test-id": "OrderDetails-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsSectionTwo */ .Ym, {
      "data-test-id": "OrderDetails-OrderDetailsSectionTwo",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ImageComponent, {
        width: "59px",
        height: "59px",
        src: packImg ? packImg : "",
        "data-test-id": "OrderDetails-ImageComponent"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        flexDirection: "column",
        "data-test-id": "OrderDetails-FlexComp",
        children: [planName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "large" : "sm",
          fontWeight: "black",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.blackText */ .rS.blackText,
          "data-test-id": "OrderDetails-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: planName,
            "data-test-id": "OrderDetails-FormattedText"
          })
        }), packName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
          fontSize: device == "lg" ? "sm" : "xs",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText7 */ .rS.greyText7,
          "data-test-id": "OrderDetails-SpanTag",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: packName,
            "data-test-id": "OrderDetails-FormattedText"
          })
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsList */ .ap, {
      "data-test-id": "OrderDetails-OrderDetailsList",
      children: orderDetailAmt && orderDetailAmt?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == (orderDetailAmt?.length ?? 0) - 1 ? "0 30px 8px" : "0 30px 8px",
          margin: "0 0 8px",
          "data-test-id": `OrderDetails-FlexComp-${index}`,
          children: [item.orderDetail && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: index == 0 ? "sm" : "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.greyText */ .rS.greyText,
            fontWeight: index == 0 ? "black" : "regular",
            "data-test-id": "OrderDetails-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              value: item.orderDetail,
              "data-test-id": "OrderDetails-FormattedText"
            })
          }), item.info && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
            fontSize: index == 0 ? "md" : "xs",
            color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_3__/* .theme.blackText */ .rS.blackText,
            fontWeight: "black",
            "data-test-id": "OrderDetails-SpanTag",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              value: item.info,
              "data-test-id": "OrderDetails-FormattedText"
            })
          })]
        }, index);
      })
    }), device == "sm" && downloadPolicy && downloadPolicy?.isEnabled ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.LandingButtonWhite, {
      btnLeftIcon: downloadPolicy?.leftIconUrl,
      btnRightIcon: downloadPolicy?.rightIconUrl,
      customTitle: downloadPolicy?.buttonTitle,
      customWidth: "calc(100% - 24px)",
      margin: "0 auto",
      onClick: navigateToDownloadPolicy,
      "data-test-id": "OrderDetails-LandingButtonWhite"
    }) : null]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetails);

/***/ }),

/***/ 44665:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54904);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const OrderDetailsShimmer = ({
  orderDetails,
  margin
}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsStyle */ .mp, {
    margin: margin,
    "data-test-id": "OrderDetailsShimmer-OrderDetailsStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsSectionOne */ .Ko, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsSectionOne",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion2, {
        width: "300px",
        height: "20px",
        "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion2, {
        width: "136px",
        height: "20px",
        "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsSectionTwo */ .Ym, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsSectionTwo"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_OrderDetails_style__WEBPACK_IMPORTED_MODULE_2__/* .OrderDetailsList */ .ap, {
      "data-test-id": "OrderDetailsShimmer-OrderDetailsList",
      children: orderDetails?.orderDetailAmt && orderDetails?.orderDetailAmt?.map((item, index) => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
          justifyContent: "space-between",
          borderBottom: "1px dashed #dbdbdb",
          padding: index == (orderDetails?.orderDetailAmt?.length ?? 0) - 1 ? "0 30px 16px" : "0 30px 8px",
          margin: "0 0 8px",
          "data-test-id": `OrderDetailsShimmer-FlexComp-${index}`,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion2, {
            width: "144px",
            height: "18px",
            "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ShimmerVersion2, {
            width: "144px",
            height: "18px",
            "data-test-id": "OrderDetailsShimmer-ShimmerVersion2"
          })]
        }, index);
      })
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrderDetailsShimmer);

/***/ }),

/***/ 62955:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OrderListingComp_OrderListingComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.style.ts


const OrderListingCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderListingCompstyle__OrderListingCompStyle",
  componentId: "sc-1wp0u3b-0"
})(["background:#fff;padding:16px;display:flex;justify-content:space-between;align-items:baseline;gap:16px;border-radius:16px;cursor:pointer;div:last-child{}img{display:inline-block;margin-bottom:auto;}@media ", "{max-height:100%;gap:12px;border-radius:0;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.tsx











const analytics = (0,insurance/* getAnalytics */.I)();

const OrderListingComp = ({
  data
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: data?.map((item, index) => {
      const {
        icon,
        orderDate,
        bookingId,
        amount,
        insurerName,
        countries,
        currency,
        validity,
        status,
        isPassportDetailsAvailable,
        sumInsured,
        addPassportCta
      } = item;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderListingCompStyle, {
        onClick: () => {
          analytics?.trackOrderSummaryEvents({
            actionType: "order_clicked"
          } //"click"
          );
          (0,XDMAnalytics.trackEvent)({
            event_detail: {
              booking_info: {
                booking_id: item?.bookingId || ""
              },
              event_type: "action",
              event_name: "component_cta-clicked",
              event_value: "order_clicked"
            }
          });
          (0,XDMAnalytics.triggerPageExit)();
          navigation/* navigationActions.navigateToOrderDetails */.ej.navigateToOrderDetails({
            bookingId: item.bookingId
          });
        },
        "data-test-id": `OrderListingComp-OrderListingCompStyle-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
          width: "20px",
          height: "20px",
          src: icon,
          "data-test-id": "OrderListingComp-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
          gap: "12px",
          flexDirection: "column",
          flex: "1",
          "data-test-id": "OrderListingComp-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
            "data-test-id": "OrderListingComp-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              flex: "2",
              gap: "8px",
              flexDirection: device == "lg" ? "row" : "column",
              "data-test-id": "OrderListingComp-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "0px",
                "data-test-id": "OrderListingComp-FlexComp",
                children: [insurerName && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: device == "lg" ? "md" : "sm",
                  fontWeight: "black",
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: insurerName,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), countries && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: device == "lg" ? "sm" : "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: countries,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
                flex: "1",
                flexDirection: "column",
                gap: "2px",
                "data-test-id": "OrderListingComp-FlexComp",
                children: [sumInsured && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: device == "lg" ? "md" : "xs",
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: sumInsured,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), validity && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ParaTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: validity,
                    "data-test-id": "OrderListingComp-FormattedText"
                  }), status && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
                    fontWeight: "black",
                    color: status == "EXPIRED" ? Global/* theme.yellowText */.rS.yellowText : Global/* theme.greenText */.rS.greenText,
                    fontSize: "xs",
                    "data-test-id": "OrderListingComp-SpanTag",
                    children: ["\xA0 (", status, ")"]
                  })]
                }), bookingId && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ParaTag, {
                  fontSize: "xs",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-ParaTag",
                  children: ["Order ID: \xA0", /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: bookingId,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
              alignItems: "flex-end",
              flexDirection: "column",
              gap: "8px",
              flex: "1",
              "data-test-id": "OrderListingComp-FlexComp",
              children: [amount && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ParaTag, {
                fontSize: "md",
                fontWeight: "black",
                "data-test-id": "OrderListingComp-ParaTag",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: amount,
                  "data-test-id": "OrderListingComp-FormattedText"
                }), currency && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                  fontSize: "md",
                  fontWeight: "black",
                  color: Global/* theme.greyText */.rS.greyText,
                  "data-test-id": "OrderListingComp-SpanTag",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: currency,
                    "data-test-id": "OrderListingComp-FormattedText"
                  })
                }), "\xA0"]
              }), orderDate && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                fontSize: "xs",
                color: Global/* theme.greyText */.rS.greyText,
                margin: device == "sm" ? "auto 0 0" : "",
                "data-test-id": "OrderListingComp-ParaTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: orderDate,
                  "data-test-id": "OrderListingComp-FormattedText"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
              margin: "2px 4px 4px",
              "data-test-id": "OrderListingComp-AnchorTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                width: "12px",
                height: "12px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/blue_Chev_2800e4f975.svg",
                "data-test-id": "OrderListingComp-ImageComponent"
              })
            })]
          }), isPassportDetailsAvailable && item.bookingId && /*#__PURE__*/(0,jsx_runtime.jsx)(components.OrderStatusComp, {
            ctatText: addPassportCta,
            orderStatus: "Pending",
            orderPending: true,
            bookingId: item?.bookingId,
            "data-test-id": "OrderListingComp-OrderStatusComp"
          })]
        })]
      }, index);
    })
  });
};

/* harmony default export */ const OrderListingComp_OrderListingComp = (OrderListingComp);

/***/ }),

/***/ 68938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ OrderStatusComp_OrderStatusComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/static/css/Global.ts
var Global = __webpack_require__(81594);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.style.ts

const OrderStatusCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderStatusCompstyle__OrderStatusCompStyle",
  componentId: "sc-1e3p997-0"
})(["display:flex;align-items:center;justify-content:space-between;gap:10px;border-radius:2px;padding:4px 8px;background:", ";"], p => p.pending ? "#FFEDD1" : p.failed ? "#FCDADB" : "#fff");
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.tsx









const OrderStatusComp = ({
  orderStatus,
  orderFailed,
  orderPending,
  ctatText,
  bookingId
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderStatusCompStyle, {
    pending: orderPending,
    failed: orderFailed,
    "data-test-id": "OrderStatusComp-OrderStatusCompStyle",
    children: [orderStatus && /*#__PURE__*/(0,jsx_runtime.jsxs)(components.SpanTag, {
      fontSize: "xs",
      fontWeight: "bold",
      color: orderFailed ? Global/* theme.redText */.rS.redText : orderPending ? Global/* theme.brownText */.rS.brownText : Global/* theme.blackText */.rS.blackText,
      "data-test-id": "OrderStatusComp-SpanTag",
      children: [orderPending && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        fontWeight: "regular",
        "data-test-id": "OrderStatusComp-SpanTag",
        children: "Documents:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: orderStatus,
        "data-test-id": "OrderStatusComp-FormattedText"
      })]
    }), "\xA0\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
      handleClick: () => navigation/* navigationActions.navigateToAddPassport */.ej.navigateToAddPassport({
        bookingId,
        pageId: src.PASSPORT_DETAILS_PAGE_ID.ORDER_CONFIRMED
      }),
      alignItems: "center",
      gap: "4px",
      "data-test-id": "OrderStatusComp-FlexComp",
      children: [ctatText && /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "OrderStatusComp-AnchorTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: ctatText,
          "data-test-id": "OrderStatusComp-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
        width: "16px",
        height: "16px",
        src: "https://tripmoneycmsimgak.mmtcdn.com/img/right_arrow_4a1f2bfef9.svg",
        "data-test-id": "OrderStatusComp-ImageComponent"
      })]
    })]
  });
};

/* harmony default export */ const OrderStatusComp_OrderStatusComp = (OrderStatusComp);

/***/ }),

/***/ 69749:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _PassportNumComp_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8453);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const AddPassportModal = ({
  handleSkip,
  handleClose,
  data
}) => {
  const {
    title,
    info,
    addBtnText,
    skipBtnText
  } = data || {};
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.CommonModalDweb, {
    handleClick: handleClose,
    customTitle: title,
    customIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/Geeric_caution_b863e71f7f.svg",
    nonClipHeading: true,
    "data-test-id": "AddPassportModal-CommonModalDweb",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ParaTag, {
      fontSize: "md",
      color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText */ .rS.greyText,
      "data-test-id": "AddPassportModal-ParaTag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
        value: info,
        "data-test-id": "AddPassportModal-FormattedText"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
      justifyContent: "space-between",
      alignItems: "center",
      margin: "26px 0 0",
      gap: "10px",
      "data-test-id": "AddPassportModal-FlexComp",
      children: [addBtnText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.LandingButton, {
        onClick: handleClose,
        customWidth: "122px",
        customTitle: addBtnText,
        "data-test-id": "AddPassportModal-LandingButton"
      }), skipBtnText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.AnchorTag, {
        handleClick: handleSkip,
        fontSize: "md",
        fontWeight: "bold",
        "data-test-id": "AddPassportModal-AnchorTag",
        children: skipBtnText
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddPassportModal);

/***/ }),

/***/ 8453:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BU": () => (/* binding */ PassportNumCompStyle),
/* harmony export */   "Ls": () => (/* binding */ ButtonWrap),
/* harmony export */   "_W": () => (/* binding */ PassportHd),
/* harmony export */   "pq": () => (/* binding */ PassportItem)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88025);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45590);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84576);




const PassportNumCompStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportNumCompStyle",
  componentId: "sc-4ddzx4-0"
})(["background:#ffffff;border-radius:16px;box-shadow:0px 3px 30px rgba(0,0,0,0.16);flex:1;display:flex;flex-direction:column;@media ", "{border-radius:16px 16px 0 0;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile);
const PassportHd = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportHd",
  componentId: "sc-4ddzx4-1"
})(["padding:30px;border-bottom:1px solid #e8e8e8;display:flex;flex-direction:column;gap:8px;@media ", "{padding:24px 16px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile);
const PassportItem = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PassportNumCompstyle__PassportItem",
  componentId: "sc-4ddzx4-2"
})(["display:grid;grid-template-columns:repeat(2,1fr);border-bottom:", ";padding:16px 30px;gap:8px;@media ", "{grid-template-columns:repeat(1,1fr);padding:16px;}"], p => p.itemIndex ? "none" : "1px solid #e8e8e8", _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile);
const ButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l).withConfig({
  displayName: "PassportNumCompstyle__ButtonWrap",
  componentId: "sc-4ddzx4-3"
})(["display:flex;align-items:center;padding:30px;margin-top:auto;", "{flex:1;}", "{flex:1;text-align:center;}@media ", "{padding:24px 16px;}"], _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_2__/* .LandingButtonStyle */ .zm, _FlexComp_FlexComp_style__WEBPACK_IMPORTED_MODULE_1__/* .FlexCompStyle */ .l, _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile);

/***/ }),

/***/ 31799:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63955);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42874);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44928);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50354);
/* harmony import */ var _PassportNumComp_style__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8453);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52322);











const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_3__/* .getAnalytics */ .I)();

const PassportNumComp = ({
  isLoading,
  title,
  info,
  travellerData,
  submitCtaText,
  skipCtaText,
  passportFormData,
  handleSubmitClick,
  handleAddPassportModal
}) => {
  const {
    isRequired,
    label,
    placeHolder,
    pattern,
    maxLength,
    error_message
  } = passportFormData || {};
  const travellerCount = travellerData?.length || 0;
  const {
    control,
    formState,
    handleSubmit
  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .useForm */ .cI)({
    defaultValues: {
      //array name should match with field array name in useFieldAray()
      passportData: Array.from({
        length: travellerCount
      }).map((_, index) => ({
        name: travellerData?.[index]?.name || "",
        passport: travellerData?.[index]?.passportNum || ""
      }))
    },
    mode: "onTouched"
  });
  const {
    fields
  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .useFieldArray */ .Dq)({
    control,
    name: "passportData" // unique name for field array

  });
  const {
    errors
  } = formState;

  const onSubmit = formData => {
    analytics?.trackAddPassportEvents({
      actionType: "submit_clicked"
    } //"click"
    );
    analytics?.trackAddPassportEvents({
      actionType: "details_filled"
    } //"click"
    );
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_6__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "passport_submit_clicked"
      }
    });
    const {
      passportData
    } = formData || {};
    const reqData = travellerData?.map((item, index) => {
      const {
        refId,
        name,
        dob = "",
        gender
      } = item || {};
      return {
        refId,
        FullName: name,
        Dob: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(dob, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.DATE_FORMATS["YYYY-MM-DD"]),
        Gender: gender,
        PassportNo: passportData[index].passport
      };
    });
    handleSubmitClick(reqData);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_PassportNumComp_style__WEBPACK_IMPORTED_MODULE_7__/* .PassportNumCompStyle */ .BU, {
    "data-test-id": "PassportNumComp-PassportNumCompStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_PassportNumComp_style__WEBPACK_IMPORTED_MODULE_7__/* .PassportHd */ ._W, {
      "data-test-id": "PassportNumComp-PassportHd",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.H5Tag, {
        "data-test-id": "PassportNumComp-H5Tag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: title,
          "data-test-id": "PassportNumComp-FormattedText"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
        fontSize: "sm",
        color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.greyText */ .rS.greyText,
        "data-test-id": "PassportNumComp-ParaTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: info,
          "data-test-id": "PassportNumComp-FormattedText"
        })
      })]
    }), fields.map((item, index) => {
      const error = errors?.passportData?.[index];
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_PassportNumComp_style__WEBPACK_IMPORTED_MODULE_7__/* .PassportItem */ .pq, {
        itemIndex: index == fields.length - 1,
        "data-test-id": `PassportNumComp-PassportItem-${index}`,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .Controller */ .Qr, {
          control: control,
          name: `passportData.${index}.passport`,
          rules: {
            required: {
              value: isRequired ?? true,
              message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFormFieldErrorMsg */ .YV)("passport")
            },
            pattern: {
              value: new RegExp(pattern || ""),
              message: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFormFieldErrorMsg */ .YV)("passport", error_message)
            }
          },
          render: ({
            field: {
              onChange,
              onBlur,
              value
            }
          }) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.SpanTag, {
              fontSize: "md",
              fontWeight: "bold",
              color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_2__/* .theme.blackText */ .rS.blackText,
              "data-test-id": "PassportNumComp-SpanTag",
              children: item.name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.LandingInput, {
              requiredField: isRequired,
              placeholderTxt: placeHolder,
              labelTxt: label,
              errorState: error?.passport?.message,
              inputValue: value,
              maxInputLength: maxLength,
              disableState: isLoading,
              handleChange: onChange,
              handleBlur: onBlur,
              "data-test-id": "PassportNumComp-LandingInput"
            })]
          }),
          "data-test-id": "PassportNumComp-Controller"
        })
      }, index);
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_PassportNumComp_style__WEBPACK_IMPORTED_MODULE_7__/* .ButtonWrap */ .Ls, {
      alignItems: "center",
      gap: "24px",
      "data-test-id": "PassportNumComp-ButtonWrap",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.LandingButton, {
        isLoading: isLoading,
        customTitle: submitCtaText,
        onClick: handleSubmit(onSubmit),
        "data-test-id": "PassportNumComp-LandingButton"
      }), skipCtaText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
        "data-test-id": "PassportNumComp-FlexComp",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.AnchorTag, {
          fontSize: "md",
          fontWeight: "bold",
          handleClick: handleAddPassportModal,
          "data-test-id": "PassportNumComp-AnchorTag",
          children: skipCtaText
        })
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PassportNumComp);

/***/ }),

/***/ 93252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PaymentOfferBreakdown_PaymentOfferBreakdown)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentOfferBreakdown/PaymentOfferBreakdown.style.ts


const PaymentOfferBreakdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__PaymentOfferBreakdownWrapper",
  componentId: "g90eq4-0"
})(["width:1200px;margin:0 auto;border-radius:16px;background:", ";display:flex;justify-content:space-between;align-items:flex-end;"], Global/* theme.whiteText */.rS.whiteText);
const TitleDescriptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__TitleDescriptionWrapper",
  componentId: "g90eq4-1"
})(["padding:40px;flex-direction:column;gap:20px;width:550px;display:flex;width:55%;"]);
const SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__SectionTitle",
  componentId: "g90eq4-2"
})(["font-size:32px;font-weight:900;color:", ";"], Global/* theme.blackText */.rS.blackText);
const SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__SectionDescription",
  componentId: "g90eq4-3"
})(["font-size:16px;font-weight:400;color:#4a4a4a;margin-bottom:24px;line-height:1.5;width:80%;"]);
const OfferCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__OfferCardWrapper",
  componentId: "g90eq4-4"
})(["background-image:url(\"https://tripmoneycmsimgak.mmtcdn.com/img/Frame_2147224415_3x_138716eb84.png\");background-size:contain;background-position:center;background-repeat:no-repeat;margin-top:auto;display:flex;gap:17px;padding:26px 0 26px 75px;position:relative;width:45%;"]);
const OfferCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__OfferCard",
  componentId: "g90eq4-5"
})(["background:", ";border-radius:12px;overflow:hidden;box-shadow:0px 0px 24px 0px ", ";width:303px;padding:16px 12px;"], Global/* theme.whiteText */.rS.whiteText, Global/* theme.lightBlack */.rS.lightBlack);
const CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__CardHeader",
  componentId: "g90eq4-6"
})(["padding:16px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #e0e0e0;"]);
const CardTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__CardTitle",
  componentId: "g90eq4-7"
})(["font-size:16px;font-weight:900;color:", ";"], Global/* theme.greyText */.rS.greyText);
const CardImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "PaymentOfferBreakdownstyle__CardImage",
  componentId: "g90eq4-8"
})(["left:275px;top:25.5px;position:absolute;width:303px;height:auto;object-fit:contain;"]);
const AmountBreakdownList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__AmountBreakdownList",
  componentId: "g90eq4-9"
})(["display:flex;flex-direction:column;"]);
const AmountRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentOfferBreakdownstyle__AmountRow",
  componentId: "g90eq4-10"
})(["display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:400;padding:8px;color:", ";background-color:", ";&:last-child{border-top:1px solid ", ";}"], Global/* theme.greyText */.rS.greyText, props => props.bgColor || Global/* theme.whiteText */.rS.whiteText, Global/* theme.lightGrey */.rS.lightGrey);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentOfferBreakdown/PaymentOfferBreakdown.tsx









const PaymentOfferBreakdown = ({
  data
}) => {
  if (!data || !data.card) return null;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "payment_offer_breakdown_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: paymentOfferBreakdownRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentOfferBreakdownWrapper, {
    ref: paymentOfferBreakdownRef,
    "data-test-id": "PaymentOfferBreakdown-PaymentOfferBreakdownWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleDescriptionWrapper, {
      "data-test-id": "PaymentOfferBreakdown-TitleDescriptionWrapper",
      children: [data.title && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
        "data-test-id": "PaymentOfferBreakdown-SectionTitle",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.title,
          "data-test-id": "PaymentOfferBreakdown-FormattedText"
        })
      }), data.description && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
        "data-test-id": "PaymentOfferBreakdown-SectionDescription",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: data.description,
          "data-test-id": "PaymentOfferBreakdown-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OfferCardWrapper, {
      "data-test-id": "PaymentOfferBreakdown-OfferCardWrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OfferCard, {
        "data-test-id": "PaymentOfferBreakdown-OfferCard",
        children: [data.card.title && /*#__PURE__*/(0,jsx_runtime.jsx)(CardTitle, {
          "data-test-id": "PaymentOfferBreakdown-CardTitle",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: data.card.title,
            "data-test-id": "PaymentOfferBreakdown-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AmountBreakdownList, {
          "data-test-id": "PaymentOfferBreakdown-AmountBreakdownList",
          children: data.card.amount?.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(AmountRow, {
            bgColor: item.bgColor,
            "data-test-id": `PaymentOfferBreakdown-AmountRow-${index}`,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.title,
              baseStyle: {
                fontWeight: 400,
                fontSize: "14px",
                color: Global/* theme.greyText */.rS.greyText
              },
              "data-test-id": "PaymentOfferBreakdown-FormattedText"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: item.cost,
              baseStyle: {
                fontWeight: 700,
                fontSize: "14px",
                color: Global/* theme.greyText */.rS.greyText
              },
              "data-test-id": "PaymentOfferBreakdown-FormattedText"
            })]
          }, index))
        })]
      }), data.card.image && /*#__PURE__*/(0,jsx_runtime.jsx)(CardImage, {
        src: data.card.image,
        alt: "offer",
        "data-test-id": "PaymentOfferBreakdown-CardImage"
      })]
    })]
  });
};

/* harmony default export */ const PaymentOfferBreakdown_PaymentOfferBreakdown = (PaymentOfferBreakdown);

/***/ }),

/***/ 66365:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PaymentStatusComp_PaymentStatusComp)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.style.ts

const PaymentStatusCompStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentStatusCompstyle__PaymentStatusCompStyle",
  componentId: "v9sidz-0"
})(["background:#fff;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
const Confetti = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentStatusCompstyle__Confetti",
  componentId: "v9sidz-1"
})(["width:278px;height:185px;animation:confetti 0.5s ease-in;@keyframes confetti{0%{transform:scale(0.5);}100%{transform:scale(1);}}"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.tsx







const PaymentStatusComp = ({
  title,
  infoTxt,
  subInfoTxt,
  imageIcon
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentStatusCompStyle, {
    "data-test-id": "PaymentStatusComp-PaymentStatusCompStyle",
    children: [imageIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(Confetti, {
      "data-test-id": "PaymentStatusComp-Confetti",
      children: imageIcon
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
      fontSize: "large",
      fontWeight: "bold",
      margin: "0 0 8px",
      color: Global/* theme.blackText */.rS.blackText,
      "data-test-id": "PaymentStatusComp-ParaTag",
      children: title
    }), infoTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      margin: "0 0 2px",
      fontSize: "xs",
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "PaymentStatusComp-SpanTag",
      children: infoTxt
    }), subInfoTxt && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontSize: "xs",
      color: Global/* theme.greyText */.rS.greyText,
      "data-test-id": "PaymentStatusComp-SpanTag",
      children: subInfoTxt
    })]
  });
};

/* harmony default export */ const PaymentStatusComp_PaymentStatusComp = (PaymentStatusComp);

/***/ }),

/***/ 82207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ PersuasionBannerStyle),
/* harmony export */   "c": () => (/* binding */ BulletListStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93139);
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84576);
/* harmony import */ var _BulletListItem_BulletListItem_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98988);
/* harmony import */ var _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45590);






const PersuasionBannerStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PersuasionBannerstyle__PersuasionBannerStyle",
  componentId: "sc-1a6nyyd-0"
})(["", " padding:30px 34px;border-radius:25px;background-image:", ";background-size:contain;background-repeat:no-repeat;display:flex;flex-direction:column;height:400px;gap:20px;em{color:", ";font-weight:700;font-style:normal;}", "{width:100%;}& ul{display:flex;flex-direction:column;gap:16px;}& li{position:relative;padding-left:16px;}& li:before{content:\"\";position:absolute;top:4px;left:0px;width:4px;border-radius:4px;height:16px;background-color:", ";}@media ", "{padding:32px 16px;background-size:cover;border:1px solid #fff;margin-bottom:16px;}", "{margin-bottom:16px;&:last-child{margin-bottom:0;}@media ", "{margin-bottom:8px;}}", "{padding:10px 40px;}"], props => props.margin && `margin: ${props.margin};`, props => `url(${props.bgImage})`, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greenText */ .rS.greenText, _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_2__/* .H3TagStyle */ .KO, _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.darkYellowText */ .rS.darkYellowText, _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile, _BulletListItem_BulletListItem_style__WEBPACK_IMPORTED_MODULE_4__/* .BulletListItemStyle */ .I, _tm_static_utils__WEBPACK_IMPORTED_MODULE_3__/* .deviceType.mobile */ .vO.mobile, _LandingButton_LandingButton_style__WEBPACK_IMPORTED_MODULE_5__/* .LandingButtonStyle */ .zm);
const BulletListStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "PersuasionBannerstyle__BulletListStyle",
  componentId: "sc-1a6nyyd-1"
})(["display:flex;flex-direction:column;"]);

/***/ }),

/***/ 55913:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87109);
/* harmony import */ var _PersuasionBanner_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82207);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const PersuasionBanner = ({
  heading,
  bgImage,
  bulletPoints,
  btnText,
  margin,
  btnHandler,
  info
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpointV2 */ .bU)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_PersuasionBanner_style__WEBPACK_IMPORTED_MODULE_2__/* .PersuasionBannerStyle */ .G, {
    margin: margin,
    bgImage: bgImage,
    "data-test-id": "PersuasionBanner-PersuasionBannerStyle",
    children: [device == "lg" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.H3Tag, {
      "data-test-id": "PersuasionBanner-H3Tag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
        value: heading,
        "data-test-id": "PersuasionBanner-FormattedText"
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.H5Tag, {
      "data-test-id": "PersuasionBanner-H5Tag",
      children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FormattedText, {
        value: heading,
        "data-test-id": "PersuasionBanner-FormattedText"
      })]
    }), device === "sm" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.FlexComp, {
      gap: "6px",
      "data-test-id": "PersuasionBanner-FlexComp",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.ParaTag, {
        dangerousText: info,
        "data-test-id": "PersuasionBanner-ParaTag"
      })
    }), bulletPoints?.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_PersuasionBanner_style__WEBPACK_IMPORTED_MODULE_2__/* .BulletListStyle */ .c, {
      "data-test-id": "PersuasionBanner-BulletListStyle",
      children: bulletPoints.map(item => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.BulletListItem, {
          "data-test-id": "PersuasionBanner-BulletListItem",
          children: [item.boldText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            fontWeight: "bold",
            "data-test-id": "PersuasionBanner-SpanTag",
            children: item.boldText
          }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.SpanTag, {
            "data-test-id": "PersuasionBanner-SpanTag",
            children: item.normalText
          })]
        }, item.id);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_0__.LandingButton, {
      customTitle: btnText,
      onClick: btnHandler,
      padding: "0px 40px",
      margin: "auto 0 0",
      "data-test-id": "PersuasionBanner-LandingButton"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PersuasionBanner);

/***/ }),

/***/ 55654:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2182);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48359);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87109);
/* harmony import */ var _tm_ui_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89565);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27481);
/* harmony import */ var _PersuasionBanner_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82207);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52322);










const PersuasionBannerInsurance = ({
  crossSell,
  btnHandler
}) => {
  const device = (0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointV2 */ .bU)();
  const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_0__/* .getAnalytics */ .I)();
  const hasTracked = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "persuasion_banner_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: persuasionBannerRef
  } = (0,_tm_ui_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useIntersectionObserver */ .S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });

  if (!crossSell) {
    return null;
  }

  const {
    title,
    background,
    description,
    cta,
    info
  } = crossSell;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_PersuasionBanner_style__WEBPACK_IMPORTED_MODULE_6__/* .PersuasionBannerStyle */ .G, {
    ref: persuasionBannerRef,
    bgImage: background?.url,
    "data-test-id": "PersuasionBannerInsurance-PersuasionBannerStyle",
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.H3Tag, {
      "data-test-id": "PersuasionBannerInsurance-H3Tag",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
        value: title,
        "data-test-id": "PersuasionBannerInsurance-FormattedText"
      })
    }), device === "sm" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FlexComp, {
      gap: "6px",
      "data-test-id": "PersuasionBannerInsurance-FlexComp",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.ParaTag, {
        "data-test-id": "PersuasionBannerInsurance-ParaTag",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.FormattedText, {
          value: info,
          "data-test-id": "PersuasionBannerInsurance-FormattedText"
        })
      })
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      value: description,
      "data-test-id": "PersuasionBannerInsurance-MarkdownText"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_1__.LandingButton, {
      customTitle: cta?.title,
      onClick: btnHandler,
      padding: "0px 40px",
      "data-test-id": "PersuasionBannerInsurance-LandingButton"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PersuasionBannerInsurance);

/***/ }),

/***/ 3925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PlanPriceInfoComp_PlanPriceInfoComp)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(38985);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PlanPriceInfoComp/PlanPriceInfoComp.styles.ts

const PlanPriceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanPriceInfoCompstyles__PlanPriceContainer",
  componentId: "q8h9wi-0"
})(["background:white;border-radius:16px;padding:16px 24px;"]);
const PlanHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanPriceInfoCompstyles__PlanHeader",
  componentId: "q8h9wi-1"
})(["margin-bottom:12px;"]);
const CancellationSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanPriceInfoCompstyles__CancellationSection",
  componentId: "q8h9wi-2"
})(["background:#f2f2f2;border-radius:12px;padding:12px;display:flex;justify-content:space-between;align-items:center;"]);
const Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PlanPriceInfoCompstyles__Separator",
  componentId: "q8h9wi-3"
})(["width:100%;height:1px;background-color:#e9ecef;margin:12px 0;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PlanPriceInfoComp/PlanPriceInfoComp.tsx











const formatDate = timestamp => {
  if (!timestamp) return "";
  const date = new Date(timestamp * 1000);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", {
    month: "short"
  });
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${day} ${month}, ${year}, ${formattedHours}:${formattedMinutes}${ampm} IST`;
};

const PlanPriceInfoComp = data => {
  const analytics = (0,insurance/* getAnalytics */.I)();
  const {
    planType,
    planInfo,
    sumInsured,
    amountToPay,
    cancellationInfo
  } = data;

  const handleEditClick = () => {
    analytics?.trackTravDetailsEvents({
      actionType: "edit_plan_price_info_clicked"
    });

    if (document.referrer) {
      navigation/* navigationActions.goBack */.ej.goBack();
    }

    const queryParams = new URLSearchParams(window.location.search);
    const params = {
      countries: queryParams.get("countries"),
      startDate: queryParams.get("startDate"),
      endDate: queryParams.get("endDate"),
      travellers: queryParams.get("travellers"),
      segment: queryParams.get("segment"),
      type: queryParams.get("type") || "",
      itineraryId: queryParams.get("itineraryId") || ""
    };
    navigation/* navigationActions.navigateToListing */.ej.navigateToListing(params);
  };

  const formattedDate = formatDate(cancellationInfo?.info?.date);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanPriceContainer, {
    "data-test-id": "PlanPriceInfoComp-PlanPriceContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlanHeader, {
      "data-test-id": "PlanPriceInfoComp-PlanHeader",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        "data-test-id": "PlanPriceInfoComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: planType,
          baseStyle: {
            fontWeight: 900,
            fontSize: "14px"
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnchorTag/* default */.Z, {
          handleClick: handleEditClick,
          "data-test-id": "PlanPriceInfoComp-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
            width: "24px",
            height: "24px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/edit_Icon_be6c24806a.svg",
            "data-test-id": "PlanPriceInfoComp-ImageComponent"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {
      "data-test-id": "PlanPriceInfoComp-Separator"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      justifyContent: "space-between",
      alignItems: "flex-start",
      margin: "0 0 12px 0",
      "data-test-id": "PlanPriceInfoComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        gap: "12px",
        alignItems: "center",
        "data-test-id": "PlanPriceInfoComp-FlexComp",
        children: [planInfo.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
          width: "22px",
          height: "22px",
          src: planInfo.icon,
          "data-test-id": "PlanPriceInfoComp-ImageComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: planInfo.name,
          baseStyle: {
            fontWeight: 900,
            fontSize: "16px",
            color: Global/* theme.blackText */.rS.blackText
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "4px",
        "data-test-id": "PlanPriceInfoComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: sumInsured,
          baseStyle: {
            fontWeight: 400,
            fontSize: "16px",
            color: Global/* theme.greyText */.rS.greyText
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: amountToPay,
          baseStyle: {
            fontWeight: 400,
            fontSize: "16px",
            color: Global/* theme.greyText */.rS.greyText
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        })]
      })]
    }), cancellationInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(CancellationSection, {
      "data-test-id": "PlanPriceInfoComp-CancellationSection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: cancellationInfo.title,
        baseStyle: {
          fontWeight: 900,
          fontSize: "16px",
          color: Global/* theme.blackText */.rS.blackText
        },
        "data-test-id": "PlanPriceInfoComp-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        gap: "4px",
        "data-test-id": "PlanPriceInfoComp-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: cancellationInfo.info?.prefix,
          baseStyle: {
            fontSize: "16px",
            color: Global/* theme.blackText */.rS.blackText
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: `${formattedDate}`,
          baseStyle: {
            fontSize: "16px",
            color: Global/* theme.blackText */.rS.blackText,
            fontWeight: 700
          },
          "data-test-id": "PlanPriceInfoComp-FormattedText"
        })]
      })]
    })]
  });
};

/* harmony default export */ const PlanPriceInfoComp_PlanPriceInfoComp = (PlanPriceInfoComp);

/***/ }),

/***/ 94879:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PoweredBySection_PoweredBySection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PoweredBySection/PoweredBySection.style.ts


const PoweredByContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PoweredBySectionstyle__PoweredByContainer",
  componentId: "or0os6-0"
})(["width:1200px;gap:12px;border-radius:16px;padding:20px 16px;font-weight:400;font-size:16px;margin:0 auto;background:", ";"], Global/* theme.whiteText */.rS.whiteText);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PoweredBySection/PoweredBySection.tsx










const PoweredBySection = ({
  data
}) => {
  const {
    icon,
    title,
    description
  } = data;
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "powered_by_section_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: poweredBySectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PoweredByContainer, {
    ref: poweredBySectionRef,
    "data-test-id": "PoweredBySection-PoweredByContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      alignItems: "center",
      gap: "4px",
      "data-test-id": "PoweredBySection-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "PoweredBySection-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
        src: icon,
        height: "48px",
        width: "auto",
        "data-test-id": "PoweredBySection-ImageComponent"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: description,
      "data-test-id": "PoweredBySection-FormattedText"
    })]
  });
};

/* harmony default export */ const PoweredBySection_PoweredBySection = (PoweredBySection);

/***/ }),

/***/ 76827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PriceBreakup_PriceBreakup)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PriceBreakup/PriceBreakup.styles.ts

const PriceBreakupContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PriceBreakupstyles__PriceBreakupContainer",
  componentId: "j1xbmm-0"
})(["background:white;border-radius:16px;padding:20px 16px;margin-bottom:20px;box-shadow:0 2px 8px rgba(0,0,0,0.1);border:1px solid #f0f0f0;"]);
const PriceBreakupTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PriceBreakupstyles__PriceBreakupTitle",
  componentId: "j1xbmm-1"
})(["margin-bottom:12px;"]);
const PriceItemSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PriceBreakupstyles__PriceItemSeparator",
  componentId: "j1xbmm-2"
})(["width:100%;height:1px;background-color:#d8d8d8;margin:12px 0;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PriceBreakup/PriceBreakup.tsx








const PriceBreakup = data => {
  const {
    title,
    pricingDetails
  } = data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceBreakupContainer, {
    "data-test-id": "PriceBreakup-PriceBreakupContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PriceBreakupTitle, {
      "data-test-id": "PriceBreakup-PriceBreakupTitle",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        baseStyle: {
          fontWeight: 900,
          fontSize: "18px",
          color: Global/* theme.blackText */.rS.blackText
        },
        "data-test-id": "PriceBreakup-FormattedText"
      })
    }), pricingDetails.map((detail, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "PriceBreakup-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: detail.label,
            baseStyle: {
              fontWeight: 700,
              fontSize: "14px",
              color: Global/* theme.greyText */.rS.greyText
            },
            "data-test-id": "PriceBreakup-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: detail.amount,
            baseStyle: {
              fontWeight: 700,
              fontSize: "14px",
              color: Global/* theme.greyText */.rS.greyText
            },
            "data-test-id": "PriceBreakup-FormattedText"
          })]
        }), detail.description && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: detail.description,
          baseStyle: {
            fontWeight: 400,
            fontSize: "14px",
            color: Global/* theme.greyText */.rS.greyText,
            marginTop: "4px"
          },
          "data-test-id": "PriceBreakup-FormattedText"
        })]
      }), index < pricingDetails.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(PriceItemSeparator, {
        "data-test-id": "PriceBreakup-PriceItemSeparator"
      })]
    }, `price-breakup-${index}`))]
  });
};

/* harmony default export */ const PriceBreakup_PriceBreakup = (PriceBreakup);

/***/ }),

/***/ 3149:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PrimaryContactComp_PrimaryContactComp)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.tsx + 1 modules
var CountryCodeInput = __webpack_require__(21864);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.tsx + 1 modules
var LandingInput = __webpack_require__(48741);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/SpanTag.tsx
var SpanTag = __webpack_require__(56893);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PrimaryContactComp/PrimaryContactComp.styles.ts

const PrimaryContactContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PrimaryContactCompstyles__PrimaryContactContainer",
  componentId: "eo2vgg-0"
})(["background:#ffffff;border-radius:16px;padding:24px;"]);
const PrimaryContactNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PrimaryContactCompstyles__PrimaryContactNote",
  componentId: "eo2vgg-1"
})(["background:rgba(255,237,209,1);border-radius:8px;padding:12px 16px;margin-top:16px;display:flex;flex-direction:column;gap:8px;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PrimaryContactComp/PrimaryContactComp.tsx












const PrimaryContactComp = /*#__PURE__*/(0,react.forwardRef)(({
  primaryContact,
  note,
  setValue,
  saveFormValuesOnBlur,
  handleCountryCodeModal,
  selectedCountry,
  isLoading
}, ref) => {
  const {
    title,
    info,
    isEditable,
    fields
  } = primaryContact || {};
  const {
    email,
    mobile
  } = fields || {};
  const {
    control,
    formState: {
      errors
    }
  } = (0,index_esm/* useFormContext */.Gc)();
  const internalRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, () => internalRef.current);
  (0,react.useEffect)(() => {
    setValue("primaryContactData", {
      mobile: primaryContact?.fields?.mobile?.value || "",
      email: primaryContact?.fields?.email?.value || ""
    });
  }, [primaryContact]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PrimaryContactContainer, {
    ref: internalRef,
    "data-test-id": "PrimaryContactComp-PrimaryContactContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      flexDirection: "column",
      gap: "8px",
      margin: "0 0 16px 0",
      "data-test-id": "PrimaryContactComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        baseStyle: {
          fontSize: "22px",
          fontWeight: "900",
          color: "#000000"
        },
        "data-test-id": "PrimaryContactComp-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: info,
        baseStyle: {
          fontSize: "14px",
          fontWeight: "400",
          color: "#4a4a4a"
        },
        "data-test-id": "PrimaryContactComp-FormattedText"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      flexDirection: "row",
      gap: "16px",
      "data-test-id": "PrimaryContactComp-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "primaryContactData.mobile",
        rules: {
          required: {
            value: mobile?.isRequired ?? true,
            message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile")
          },
          pattern: {
            value: new RegExp(mobile?.regex || ""),
            message: (0,utils/* getFormFieldErrorMsg */.YV)("mobile", mobile?.errorMessage)
          }
        },
        render: ({
          field: {
            onChange,
            onBlur,
            value
          }
        }) => /*#__PURE__*/(0,jsx_runtime.jsx)(CountryCodeInput/* default */.Z, {
          errorState: errors?.primaryContactData?.mobile?.message,
          inputValue: value,
          handleChange: onChange,
          handleBlur: () => {
            saveFormValuesOnBlur?.();
            onBlur();
          },
          placeholderTxt: mobile?.placeholder,
          requiredField: mobile?.isRequired,
          labelTxt: mobile?.title,
          inputType: "tel",
          disableState: isLoading,
          autoComplete: "off",
          flex: "1",
          inputWidth: "50%",
          handleCountryCodeModal: handleCountryCodeModal,
          countryFlag: selectedCountry?.countryFlag,
          countryCode: selectedCountry?.countryCode || "+91",
          isDisabled: !isEditable,
          backgroundColor: "#F2F2F2",
          "data-test-id": "PrimaryContactComp-CountryCodeInput"
        }),
        "data-test-id": "PrimaryContactComp-Controller"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        control: control,
        name: "primaryContactData.email",
        rules: {
          required: {
            value: email?.isRequired ?? true,
            message: (0,utils/* getFormFieldErrorMsg */.YV)("email")
          },
          pattern: {
            value: new RegExp(email?.regex || ""),
            message: (0,utils/* getFormFieldErrorMsg */.YV)("email", email?.errorMessage)
          }
        },
        render: ({
          field: {
            onChange,
            onBlur,
            value
          }
        }) => /*#__PURE__*/(0,jsx_runtime.jsx)(LandingInput/* default */.Z, {
          inputValue: value,
          handleChange: onChange,
          handleBlur: () => {
            saveFormValuesOnBlur?.();
            onBlur();
          },
          placeholderTxt: email?.placeholder,
          requiredField: email?.isRequired,
          labelTxt: email?.title,
          errorState: errors?.primaryContactData?.email?.message,
          disableState: isLoading,
          autoComplete: "off",
          flex: "1",
          inputWidth: "50%",
          isDisabled: !isEditable,
          backgroundColor: Global/* theme.disabledGrey2 */.rS.disabledGrey2,
          "data-test-id": "PrimaryContactComp-LandingInput"
        }),
        "data-test-id": "PrimaryContactComp-Controller"
      })]
    }), note && /*#__PURE__*/(0,jsx_runtime.jsxs)(PrimaryContactNote, {
      "data-test-id": "PrimaryContactComp-PrimaryContactNote",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        color: Global/* theme.brownText */.rS.brownText,
        fontWeight: "bold",
        "data-test-id": "PrimaryContactComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: note.title,
          "data-test-id": "PrimaryContactComp-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        color: Global/* theme.brownText */.rS.brownText,
        "data-test-id": "PrimaryContactComp-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: note?.info,
          "data-test-id": "PrimaryContactComp-FormattedText"
        })
      })]
    })]
  });
});
PrimaryContactComp.displayName = "PrimaryContactComp";
/* harmony default export */ const PrimaryContactComp_PrimaryContactComp = (PrimaryContactComp);

/***/ }),

/***/ 33570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ RadioButtonStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);

const RadioButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RadioButtonstyle__RadioButtonStyle",
  componentId: "zyhzua-0"
})(["", " display:flex;", " label{user-select:none;}input{display:none;}[type=\"radio\"]:checked,[type=\"radio\"]:not(:checked){position:absolute;left:-9999px;}[type=\"radio\"]:checked + label,[type=\"radio\"]:not(:checked) + label{position:relative;padding-left:24px;cursor:pointer;display:inline-flex;color:#666;width:100%;", "}[type=\"radio\"]:checked + label:before,[type=\"radio\"]:not(:checked) + label:before{content:\"\";position:absolute;left:0;top:0px;width:15px;height:15px;border:1px solid var(--tm-accent-color);border-radius:100%;background:#fff;", "}[type=\"radio\"]:checked + label:after,[type=\"radio\"]:not(:checked) + label:after{content:\"\";width:9px;height:9px;background:var(--tm-accent-color);position:absolute;top:3px;left:3px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;", "}[type=\"radio\"]:not(:checked) + label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}[type=\"radio\"]:checked + label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}"], p => p.isPadding && `
    padding: 16px 10px;
`, p => p.showLabel && `
        width: 100%;
`, p => !p.showLabel && `
        margin-top:-12px
`, p => !p.showLabel && `
        margin-top:-12px
`, p => !p.showLabel && `
        margin-top:-12px
`);

/***/ }),

/***/ 11627:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _RadioButton_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33570);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);





const RadioButton = ({
  children,
  activeBtn,
  handleChange,
  inputIndex,
  inputId,
  isPadding,
  showLabel = true
}) => {
  const handleRadioChange = () => {
    if (handleChange && inputIndex !== undefined) {
      handleChange(inputIndex);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_RadioButton_style__WEBPACK_IMPORTED_MODULE_1__/* .RadioButtonStyle */ .o, {
    isPadding: isPadding,
    onChange: handleRadioChange,
    showLabel: showLabel,
    "data-test-id": "RadioButton-RadioButtonStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
      type: "radio",
      onChange: handleRadioChange,
      checked: activeBtn,
      id: inputId,
      name: "radio-group"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("label", {
      htmlFor: inputId,
      "data-test-id": "RadioButton-label",
      children: children
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RadioButton);

/***/ }),

/***/ 7638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ RangeDatePicker_RangeDatePicker)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/index.js + 43 modules
var esm = __webpack_require__(91997);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/utils/index.js

// Holidays array
const holidays = [{
  date: "2023-03-08",
  name: "Holi"
}, {
  date: "2023-03-30",
  name: "Ram Navami"
}, {
  date: "2023-04-04",
  name: "Mahavir Jayanti"
}, {
  date: "2023-04-07",
  name: "Good Friday"
}, {
  date: "2023-04-22",
  name: "Eid-ul-fitr"
}, {
  date: "2023-05-01",
  name: "Labor Day"
}, {
  date: "2023-05-05",
  name: "Budhha Purnima"
}, {
  date: "2023-07-29",
  name: "Muharram"
}, {
  date: "2023-08-15",
  name: "Independence Day"
}, {
  date: "2023-08-29",
  name: "Onam"
}, {
  date: "2023-08-30",
  name: "Raksha Bandhan"
}, {
  date: "2023-09-07",
  name: "Ganesh Chaturthi"
}, {
  date: "2023-10-02",
  name: "Gandhi Jayanti"
}, {
  date: "2023-10-24",
  name: "Dussehra"
}, {
  date: "2023-10-28",
  name: "Valmiki Jayanti"
}, {
  date: "2023-11-12",
  name: "Diwali"
}, {
  date: "2023-11-27",
  name: "Guru Nanak Jayanti"
}, {
  date: "2023-12-25",
  name: "Christmas"
}, {
  date: "2024-01-01",
  name: "New Year's Day"
}]; // Get all days in a month

function getDaysInMonth(year, month, showHolidays) {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [];
  let holidaysCount = 0;

  for (let i = 1; i <= daysInMonth; i++) {
    /* istanbul ignore next */
    if (showHolidays) {
      const dateTimestamp = Date.UTC(year, month, i);
      let isHoliday = false;
      let holidayName = "";
      holidays.forEach(holiday => {
        const holidayDate = new Date(holiday.date);
        const holidayTimestamp = Date.UTC(holidayDate.getFullYear(), holidayDate.getMonth(), holidayDate.getDate());

        if (dateTimestamp === holidayTimestamp) {
          isHoliday = true;
          holidayName = holiday.name;
          holidaysCount++;
        }
      });
      days.push({
        date: new Date(year, month, i),
        isHoliday: isHoliday,
        holidayName: holidayName
      });
    } else {
      days.push({
        date: new Date(year, month, i)
      });
    }
  }

  return {
    days,
    holidaysCount
  };
} // Get all calendar data

function getCalendarData(startDate, endDate, showHolidays) {
  let currentDate = startDate ? new Date(startDate) : new Date();
  const lastDate = endDate ? new Date(endDate) : new Date(currentDate.getTime() + 365 * 24 * 60 * 60 * 1000);
  let monthData = [];

  while (currentDate <= lastDate) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDay = new Date(year, month + 1, 0).getDate();
    const daysInMonth = getDaysInMonth(year, month, showHolidays);
    monthData.push({
      month: month,
      year: year,
      daysInMonth: daysInMonth,
      firstDayOfWeek: firstDay
    });
    currentDate.setMonth(month + 1);
    currentDate.setDate(1);
  }

  return monthData;
} // Generate empty cell before start date

function emptyCellBefore(data, daysInMonth) {
  const daysBefore = new Array(data).fill(null).map((_, i) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "empty",
    "data-test-id": "daysBefore"
  }, `empty-${i}`));
  return daysBefore;
} // Generate empty cell after end date

function emptyCellAfter(data, daysInMonth) {
  const emptyDaysAfter = new Array(7 - (emptyCellBefore().length + daysInMonth.days.length) % 7).fill(null).map((_, i) => /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "empty",
    "data-test-id": "emptyDaysAfter"
  }, `empty-after-${i}`));
  return emptyDaysAfter;
}
const formatDate = dateString => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Month starts from 0, so we add 1 to get the correct month.

  const year = date.getFullYear() % 100; // Get the last two digits of the year.

  return `${day}/${month}/${year}`;
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.style.ts

const CalenderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderWrap",
  componentId: "qjvs5t-0"
})(["flex:1;overflow-y:auto;padding-bottom:10px;"]);
const CalenderMonthName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderMonthName",
  componentId: "qjvs5t-1"
})(["background-color:#fff;padding:20px 16px;font-size:16px;font-weight:700;color:#4a4a4a;display:flex;align-items:center;"]);
const CalenderDays = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDays",
  componentId: "qjvs5t-2"
})(["display:grid;grid-template-columns:repeat(7,1fr);border-bottom:1px solid #e7e7e7;background-color:#f2f2f2;"]);
const CalenderDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Calendarstyle__CalenderDate",
  componentId: "qjvs5t-3"
})(["border-left:1px solid #e7e7e7;border-top:1px solid #e7e7e7;padding:20px 5px;display:flex;align-items:center;justify-content:center;background-color:#fff;position:relative;", " ", " ", ""], p => p.isSelected && ` background-color: var(--tm-accent-color);`, p => p.isWithinRange && `background-color: var(--tm-accent-bg-color);`, p => p.isDisabled && ` pointer-events: none;`);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/Calendar/Calendar.tsx









const Calendar = ({
  handleDayClick,
  startDate,
  endDate,
  monthNameType,
  yearType,
  selected,
  numberOfMonth = 13,
  maxEndDate,
  minStartDate,
  isSingleDate,
  onSingleDateSelect
}) => {
  // const [sDate, setSDate] = useState(startDate);
  // const [eDate, setEDate] = useState(endDate);
  const monthRefs = (0,react.useRef)([]);
  const calendarData = getCalendarData(new Date(), maxEndDate);
  (0,react.useEffect)(() => {
    if (selected?.from) {
      const selectedMonth = selected.from.getMonth();
      const selectedYear = selected.from.getFullYear();
      const refIndex = calendarData?.findIndex(({
        month,
        year
      }) => month === selectedMonth && year === selectedYear);
      refIndex && monthRefs.current[refIndex]?.scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }, [selected, calendarData]);

  const disabledDays = date => {
    return isBefore((0,esm/* startOfDay */.b7Q)(date), (0,esm/* startOfDay */.b7Q)(new Date())) || !!(maxEndDate && isAfter(date, maxEndDate)) || !!(minStartDate && isBefore((0,esm/* startOfDay */.b7Q)(date), (0,esm/* startOfDay */.b7Q)(minStartDate)));
  };

  const isBefore = (date1, date2) => date1 < date2;

  const isAfter = (date1, date2) => date1 > date2;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderWrap, {
    "data-test-id": "Calendar-CalenderWrap",
    children: calendarData?.map(({
      month,
      year,
      daysInMonth,
      firstDayOfWeek
    }, index) => {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: ref => monthRefs.current[index] = ref,
        "data-test-id": "Calendar",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderMonthName, {
          "data-test-id": "Calendar-CalenderMonthName",
          children: [new Date(year, month).toLocaleString("en-us", {
            month: monthNameType
          }), " ", "\xA0", new Date(year, month).toLocaleString("en-us", {
            year: yearType
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderDays, {
          "data-test-id": "Calendar-CalenderDays",
          children: [emptyCellBefore(firstDayOfWeek, daysInMonth), daysInMonth.days.map(day => {
            const d = new Date();
            const curDate = d.getDate();
            const curMonth = d.getMonth();
            const curYear = d.getFullYear();
            const isSelected = isSingleDate ? day.date.getTime() === (selected?.from && selected?.from.getTime()) : day.date.getTime() === (selected?.from && selected?.from.getTime()) || day.date.getTime() === (selected?.to && selected?.to.getTime());
            const isWithinRange = !isSingleDate && selected && day.date > selected.from && day.date < selected.to;
            const isDisabled = disabledDays(day.date);
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderDate, {
              isSelected: isSelected,
              isWithinRange: isWithinRange,
              isDisabled: isDisabled,
              onClick: isSingleDate && onSingleDateSelect ? () => onSingleDateSelect(day.date) : handleDayClick ? () => handleDayClick(day.date) : () => {},
              "data-test-id": "Calendar-CalenderDate",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                color: isSelected ? Global/* theme.whiteText */.rS.whiteText : isDisabled ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
                "data-test-id": "Calendar-SpanTag",
                children: day.date.getDate()
              })
            }, `${day.date.getFullYear()}-${day.date.getMonth()}-${day.date.getDate()}`);
          }), emptyCellAfter(firstDayOfWeek, daysInMonth)]
        })]
      }, `${index}`);
    })
  });
};

/* harmony default export */ const Calendar_Calendar = (Calendar);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.style.ts

const CalenderFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFooterWrap",
  componentId: "fnv5ae-0"
})(["background-color:#fff;padding:16px;box-shadow:0 0 6px rgba(0,0,0,0.2);position:relative;"]);
const CalenderFootRange = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalenderFootRange",
  componentId: "fnv5ae-1"
})(["display:flex;align-items:center;gap:8px;margin-bottom:16px;"]);
const CalFootRangeCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__CalFootRangeCol",
  componentId: "fnv5ae-2"
})(["flex:1;background-color:#f7f7f7;border:1px solid #e7e7e7;border-radius:2px;padding:8px 10px;height:54px;position:relative;", " &:last-child{padding:8px 10px 8px 16px;}"], p => p.selected && `
        border: 1px solid var(--tm-accent-color);
        background: var(--tm-accent-bg-color);
    `);
const BottomBarSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarFooterstyle__BottomBarSection",
  componentId: "fnv5ae-3"
})(["display:flex;align-items:center;margin-bottom:16px;gap:4px;"]);
const BottomBarIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "CalendarFooterstyle__BottomBarIcon",
  componentId: "fnv5ae-4"
})(["width:24px;height:24px;object-fit:contain;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarFooter/CalendarFooter.tsx








const CalendarFooter = ({
  checkinDate,
  checkoutDate,
  onSubmitButtonPress,
  bottomBarDescription,
  bottomBarIcon
}) => {
  const {
    0: selected,
    1: setSelected
  } = (0,react.useState)(0);
  (0,react.useEffect)(() => {
    checkinDate && setSelected(1);
    checkinDate && checkoutDate && setSelected(0);
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFooterWrap, {
    "data-test-id": "CalendarFooter-CalenderFooterWrap",
    children: [bottomBarDescription && /*#__PURE__*/(0,jsx_runtime.jsxs)(BottomBarSection, {
      "data-test-id": "CalendarFooter-BottomBarSection",
      children: [bottomBarIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBarIcon, {
        src: bottomBarIcon,
        alt: "bottomBarIcon",
        "data-test-id": "CalendarFooter-BottomBarIcon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
        value: bottomBarDescription,
        baseStyle: {
          fontSize: "14px",
          fontWeight: "700",
          color: Global/* theme.blackText */.rS.blackText
        },
        "data-test-id": "CalendarFooter-FormattedText"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderFootRange, {
      "data-test-id": "CalendarFooter-CalenderFootRange",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 0,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 0 ? `var(--tm-accent-color)` : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "start date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkinDate ? formatDate(checkinDate) : "-"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalFootRangeCol, {
        selected: selected === 1,
        "data-test-id": "CalendarFooter-CalFootRangeCol",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          textTransform: "uppercase",
          fontSize: "xs",
          fontWeight: "bold",
          color: selected === 1 ? `var(--tm-accent-color)` : Global/* theme.greyText7 */.rS.greyText7,
          "data-test-id": "CalendarFooter-ParaTag",
          children: "end date"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          fontWeight: "bold",
          "data-test-id": "CalendarFooter-ParaTag",
          children: checkoutDate ? formatDate(checkoutDate) : "-"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
      customWidth: "100%",
      onClick: onSubmitButtonPress ? () => onSubmitButtonPress(checkinDate, checkoutDate) : () => {},
      customTitle: "Confirm",
      disableState: !checkinDate || !checkoutDate,
      "data-test-id": "CalendarFooter-LandingButton"
    })]
  });
};

/* harmony default export */ const CalendarFooter_CalendarFooter = (CalendarFooter);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.style.ts

const CalenderHeaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CalendarHeaderstyle__CalenderHeaderWrap",
  componentId: "sc-1hfcczo-0"
})(["background-color:#fff;padding:12px 16px;position:sticky;display:flex;align-items:center;top:0;z-index:6;"]);
const CalHeaderBackBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "CalendarHeaderstyle__CalHeaderBackBtn",
  componentId: "sc-1hfcczo-1"
})(["width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:transparent;outline:0;border:0;position:relative;flex-shrink:0;margin-right:15px;&:after{content:\"\";border:solid #000;border-width:0 2px 2px 0;padding:5px;transform:rotate(135deg);position:absolute;left:2;}&:before{width:16px;height:2px;background-color:#000;content:\"\";flex-shrink:0;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/CalendarHeader/CalendarHeader.tsx






const CalendarHeader = ({
  checkinDate,
  checkoutDate,
  onBackPress
}) => {
  const {
    0: text,
    1: setText
  } = (0,react.useState)("Select Travel Dates");
  (0,react.useEffect)(() => {
    checkinDate && setText("Select Travel Dates");
    checkinDate && checkoutDate && setText("Select Travel Dates");
  }, [checkinDate, checkoutDate]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalenderHeaderWrap, {
    "data-test-id": "CalendarHeader-CalenderHeaderWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CalHeaderBackBtn, {
      onClick: onBackPress,
      "data-test-id": "CalendarHeader-CalHeaderBackBtn"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
      fontWeight: "bold",
      fontSize: "md",
      "data-test-id": "CalendarHeader-SpanTag",
      children: text
    })]
  });
};

/* harmony default export */ const CalendarHeader_CalendarHeader = (CalendarHeader);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.style.ts

const WeekDayWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WeekDaysstyle__WeekDayWrap",
  componentId: "rgj0qq-0"
})(["background-color:#fff;padding:2px 0;position:sticky;top:49px;z-index:1;box-shadow:0 2px 6px rgba(0,0,0,0.2);display:grid;grid-template-columns:repeat(7,1fr);span{font-size:12px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/components/WeekDays/WeekDays.tsx

 // import './WeekDays.css';




const WeekDays = ({
  top
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WeekDayWrap, {
    style: {
      top: top
    },
    "data-test-id": "WeekDays-WeekDayWrap",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sun"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Mon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Tue"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Wed"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Thu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Fri"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Sat"
    })]
  });
};

/* harmony default export */ const WeekDays_WeekDays = (WeekDays);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/styles/styles.style.ts

const calenderAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const RangeDatePickerStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__RangeDatePickerStyle",
  componentId: "r5aesx-0"
})(["display:flex;flex-direction:column;height:100%;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;"], calenderAnim);
const ErrorToast = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "stylesstyle__ErrorToast",
  componentId: "r5aesx-1"
})(["border-radius:6px;background:#fcdadb;padding:12px 16px;margin:0 16px 16px;width:auto;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx











// import './styles/styles.css';
const RangeDatePicker = ({
  calendarHeader,
  calendarWeekdays = true,
  monthNameType = "short",
  yearType = "numeric",
  calendarFooter,
  onBackPress,
  onSubmitButtonPress,
  range,
  from,
  to,
  showToast,
  toastMessage,
  handleDayClick,
  selected,
  maxEndDate,
  minStartDate,
  isSingleDate,
  onSingleDateSelect,
  bottomBarDescription,
  bottomBarIcon
}) => {
  const {
    0: startDate,
    1: setStartDate
  } = (0,react.useState)(from);
  const {
    0: endDate,
    1: setEndDate
  } = (0,react.useState)(to);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(RangeDatePickerStyle, {
    className: "cal__container",
    "data-test-id": "RangeDatePicker-RangeDatePickerStyle",
    children: [calendarHeader && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarHeader_CalendarHeader, {
      checkinDate: startDate,
      checkoutDate: endDate,
      onBackPress: onBackPress,
      "data-test-id": "RangeDatePicker-CalendarHeader"
    }), calendarWeekdays && /*#__PURE__*/(0,jsx_runtime.jsx)(WeekDays_WeekDays, {
      top: calendarHeader ? 49 : 0,
      "data-test-id": "RangeDatePicker-WeekDays"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_Calendar, {
      handleDayClick: handleDayClick,
      startDate: startDate,
      endDate: endDate,
      monthNameType: monthNameType,
      yearType: yearType,
      selected: selected,
      maxEndDate: maxEndDate,
      minStartDate: minStartDate,
      isSingleDate: isSingleDate,
      onSingleDateSelect: onSingleDateSelect,
      "data-test-id": "RangeDatePicker-Calendar"
    }), calendarFooter && /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarFooter_CalendarFooter, {
      bottomBarDescription: bottomBarDescription,
      bottomBarIcon: bottomBarIcon,
      checkinDate: selected?.from,
      checkoutDate: selected?.to,
      onSubmitButtonPress: onSubmitButtonPress ? () => onSubmitButtonPress(selected?.from, selected?.to) : () => {},
      "data-test-id": "RangeDatePicker-CalendarFooter"
    }), showToast && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorToast, {
      "data-test-id": "RangeDatePicker-ErrorToast",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
        color: Global/* theme.redText */.rS.redText,
        "data-test-id": "RangeDatePicker-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
          value: toastMessage,
          "data-test-id": "RangeDatePicker-FormattedText"
        })
      })
    })]
  });
};

/* harmony default export */ const RangeDatePicker_RangeDatePicker = (RangeDatePicker);

/***/ }),

/***/ 70629:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);




const ReactPortalComp = props => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const {
    0: mounted,
    1: setMounted
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = document.querySelector("#portal");
    setMounted(true);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return mounted && ref.current ? /*#__PURE__*/(0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    "data-test-id": "ReactPortalComp",
    children: props.children
  }), ref.current) : null;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReactPortalComp);

/***/ }),

/***/ 28376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ RecentSearches_RecentSearches)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 5 modules
var utils = __webpack_require__(62663);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RecentSearches/RecentSearches.style.tsx


const RecentSearchCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RecentSearchesstyle__RecentSearchCard",
  componentId: "chxcxt-0"
})(["display:flex;flex-direction:column;gap:2px;font-size:12px;font-weight:400;padding:8px 12px;background-color:", ";box-shadow:0px 1px 4px 0px #00000033;border-radius:8px;cursor:pointer;max-width:210px;"], Global/* theme.whiteText */.rS.whiteText);
const CountryNameText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RecentSearchesstyle__CountryNameText",
  componentId: "chxcxt-1"
})(["max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RecentSearches/RecentSearches.tsx











const RecentSearches = ({
  recentSearchInfo,
  nextPageDataCallTrigger
}) => {
  const {
    title,
    data
  } = recentSearchInfo;
  const analytics = (0,insurance/* getAnalytics */.I)();
  (0,react.useEffect)(() => {
    analytics?.trackCommonLandingEvents({
      actionType: "recent_searches_seen"
    });
  }, []);

  const formatTravelInfo = (travellerNum, travelDuration) => {
    const startDate = (0,utils/* convertUnixToDate */.P9)(travelDuration.startDate);
    const endDate = (0,utils/* convertUnixToDate */.P9)(travelDuration.endDate);

    if (!startDate || !endDate) {
      return `${travellerNum} Travellers`;
    }

    const startDay = startDate.getDate();
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const endDay = endDate.getDate();
    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();

    const yearSuffix = year => year.toString().slice(-2);

    let dateRange;

    if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
      // Same date: 11 Jan' 26
      dateRange = `${startDay} ${src.MONTHS[startMonth]}' ${yearSuffix(startYear)}`;
    } else if (startMonth === endMonth && startYear === endYear) {
      // Same month & year: 11-12 Jan' 26
      dateRange = `${startDay}-${endDay} ${src.MONTHS[startMonth]}' ${yearSuffix(startYear)}`;
    } else if (startYear === endYear) {
      // Same year, different month: 11 Jan'-12 Jul' 26
      dateRange = `${startDay} ${src.MONTHS[startMonth]}'-${endDay} ${src.MONTHS[endMonth]}' ${yearSuffix(startYear)}`;
    } else {
      // Different year: 11 Jan' 26-11 Jan' 27
      dateRange = `${startDay} ${src.MONTHS[startMonth]}' ${yearSuffix(startYear)}-${endDay} ${src.MONTHS[endMonth]}' ${yearSuffix(endYear)}`;
    }

    return `${travellerNum} Travellers, ${dateRange}`;
  };

  const MAX_COUNTRY_CHARS = 22;

  const formatCountryName = countryName => {
    if (!countryName) return "";
    const countries = countryName.split(",").map(c => c.trim());
    const totalCountries = countries.length;

    if (totalCountries === 1) {
      // Single country - truncate if too long
      if (countryName.length > MAX_COUNTRY_CHARS) {
        return countryName.slice(0, MAX_COUNTRY_CHARS - 3) + "...";
      }

      return countryName;
    } // Multiple countries


    let result = "";
    let includedCount = 0;

    for (let i = 0; i < totalCountries; i++) {
      const country = countries[i];
      const remaining = totalCountries - includedCount - 1;
      const suffix = remaining > 0 ? `..+${remaining}` : "";
      const separator = includedCount > 0 ? "," : "";
      const potentialResult = result + separator + country + suffix;

      if (potentialResult.length > MAX_COUNTRY_CHARS) {
        // Can't fit this country fully
        if (includedCount === 0) {
          // First country itself is too long - truncate it
          const suffixForAll = `..+${totalCountries - 1}`;
          const availableChars = MAX_COUNTRY_CHARS - suffixForAll.length;
          return country.slice(0, availableChars) + suffixForAll;
        } // Show what we have so far with remaining count


        const remainingCount = totalCountries - includedCount;
        return result + `..+${remainingCount}`;
      }

      result = result + separator + country;
      includedCount++;
    }

    return result;
  };

  const handleRecentSearchClick = (item, index) => {
    analytics?.trackCommonLandingEvents({
      actionType: `recent_search_${index}_clicked`
    });
    const requestData = {
      query: {
        itineraryId: new URLSearchParams(window.location.search).get("itineraryId") || "",
        source: "standalone_regular",
        type: item?.type
      },
      partner: src.PARTNER.MMT,
      userSearchIntent: {
        country: item?.countryCode,
        departureDateTime: item?.travelDuration?.startDate,
        arrivalDateTime: item?.travelDuration?.endDate,
        numberOfTravellers: item?.travellerNum,
        segment: item?.tripOption === "MULTITRIP" ? item?.tripOption : item?.planType,
        tripOption: item?.tripOption,
        planType: item?.planType
      }
    };
    nextPageDataCallTrigger(requestData);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
    gap: "8px",
    alignItems: "center",
    "data-test-id": "RecentSearches-FlexComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
      value: title,
      baseStyle: {
        fontSize: "12px",
        fontWeight: 700,
        color: Global/* theme.greyText */.rS.greyText
      },
      "data-test-id": "RecentSearches-FormattedText"
    }), data.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(RecentSearchCard, {
      onClick: () => handleRecentSearchClick(item, index),
      "data-test-id": "RecentSearches-RecentSearchCard",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: item.title,
        baseStyle: {
          color: Global/* theme.blueText */.rS.blueText
        },
        "data-test-id": "RecentSearches-FormattedText"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountryNameText, {
        "data-test-id": "RecentSearches-CountryNameText",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: formatCountryName(item.countryName),
          baseStyle: {
            fontWeight: 700,
            color: Global/* theme.blackText */.rS.blackText
          },
          "data-test-id": "RecentSearches-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: formatTravelInfo(item.travellerNum, item.travelDuration),
        baseStyle: {
          color: Global/* theme.greyText */.rS.greyText
        },
        "data-test-id": "RecentSearches-FormattedText"
      })]
    }))]
  });
};

/* harmony default export */ const RecentSearches_RecentSearches = (RecentSearches);

/***/ }),

/***/ 94884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ RegionModalDweb_RegionCountryModal)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.style.ts
var SectionDividers_style = __webpack_require__(52287);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts
var TMFloatingInput_style = __webpack_require__(40599);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.style.tsx





const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalDwebStyle",
  componentId: "h53l8r-0"
})(["position:fixed;width:", ";height:", ";max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", p => p.customHeight ? p.customHeight : "420px", SectionDividers_style/* SectionDividersStyle */.$, TMFloatingInput_style/* TMInputWrap */.dd, utils/* deviceType.mobile */.vO.mobile, modalAnim, TMFloatingInput_style/* TMInputWrap */.dd);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CommonModalHeader",
  componentId: "h53l8r-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;flex-direction:column;gap:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:85%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${TextStyles_style/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, utils/* deviceType.mobile */.vO.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionCountryModalstyle__CrossIconWrap",
  componentId: "h53l8r-2"
})(["flex-shrink:0;cursor:pointer;"]);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionCountryModal.tsx







const RegionCountryModal = ({
  children,
  customTitle,
  customSubTitle,
  handleClick,
  requiredField,
  crossIcon,
  customWidth,
  customIcon,
  errorModal,
  customHeight,
  nonClipHeading
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
    return () => {};
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ReactPortalComp, {
    "data-test-id": "RegionCountryModal-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customHeight: customHeight,
      customWidth: customWidth,
      "data-test-id": "RegionCountryModal-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionCountryModal-CommonModalHeader",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.H5Tag, {
            color: errorModal ? Global/* theme.redText */.rS.redText : Global/* theme.blackText */.rS.blackText,
            "data-test-id": "RegionCountryModal-H5Tag",
            children: [customIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "40px",
              height: "40px",
              src: customIcon,
              "data-test-id": "RegionCountryModal-ImageComponent"
            }), customTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: customTitle,
              "data-test-id": "RegionCountryModal-FormattedText"
            })]
          }), customSubTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
            value: customSubTitle,
            "data-test-id": "RegionCountryModal-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
          onClick: handleClick,
          "data-test-id": "RegionCountryModal-CrossIconWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "28px",
            height: "28px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
            "data-test-id": "RegionCountryModal-ImageComponent"
          })
        })]
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.BackDropComp, {
      onClose: handleClick,
      "data-test-id": "RegionCountryModal-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionCountryModal = (RegionCountryModal);

/***/ }),

/***/ 47233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ RegionModalDweb_RegionModalDweb)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.style.ts
var SectionDividers_style = __webpack_require__(52287);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.style.ts
var TMFloatingInput_style = __webpack_require__(40599);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.style.tsx





const modalAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const CommonModalDwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalDwebStyle",
  componentId: "c6vrw8-0"
})(["position:fixed;width:", ";height:fit-content;max-height:600px;min-height:260px;overflow-y:hidden;overflow-x:hidden;background:#ffffff;border-radius:12px;padding:0px 30px 20px;z-index:50;left:0;bottom:0;top:0;right:0;margin:auto;display:flex;flex-direction:column;", "{margin:0 -30px;}", "{position:sticky;top:74px;z-index:1;}@media ", "{width:100%;bottom:0;border-radius:12px 12px 0 0;top:unset;animation:", " 0.3s ease-in-out;", "{top:70px;}}"], p => p.customWidth ? p.customWidth : "420px", SectionDividers_style/* SectionDividersStyle */.$, TMFloatingInput_style/* TMInputWrap */.dd, utils/* deviceType.mobile */.vO.mobile, modalAnim, TMFloatingInput_style/* TMInputWrap */.dd);
const CommonModalHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CommonModalHeader",
  componentId: "c6vrw8-1"
})(["position:sticky;top:0;z-index:1;margin-left:-30px;margin-right:-30px;background:#fff;padding:20px 30px;display:flex;gap:10px;justify-content:space-between;align-items:center;", "{display:flex;gap:10px;white-space:nowrap;overflow:hidden;align-items:center;justify-content:space-between;text-overflow:ellipsis;width:100%;span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%;}}", " @media ", "{font-size:14px;line-height:19px;}"], TextStyles_style/* H5TagStyle */.Wl, p => p.nonClipHeading && `
     ${TextStyles_style/* H5TagStyle */.Wl} {
        white-space: unset;
        overflow: auto;
        width: 100%;
        span {
            overflow: auto;
            white-space: unset;
            max-width: 100%;
        }
    }
    `, utils/* deviceType.mobile */.vO.mobile);
const CrossIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RegionModalDwebstyle__CrossIconWrap",
  componentId: "c6vrw8-2"
})(["flex-shrink:0;cursor:pointer;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/RegionModalDweb/RegionModalDweb.tsx






const RegionModalDweb = ({
  children,
  customTitle,
  customWidth,
  nonClipHeading,
  handleClick
}) => {
  (0,react.useEffect)(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? parentElement.style.overflow = "unset" : "";
    return () => {
      parentElement ? parentElement.style.overflowY = "scroll" : "";
    };
  }, []);
  (0,react.useEffect)(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ReactPortalComp, {
    "data-test-id": "RegionModalDweb-ReactPortalComp",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CommonModalDwebStyle, {
      customWidth: customWidth,
      "data-test-id": "RegionModalDweb-CommonModalDwebStyle",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CommonModalHeader, {
        nonClipHeading: nonClipHeading,
        "data-test-id": "RegionModalDweb-CommonModalHeader",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(components.H5Tag, {
            "data-test-id": "RegionModalDweb-H5Tag",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: "28px",
              height: "28px",
              src: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_47_6c7992dd19.svg",
              "data-test-id": "RegionModalDweb-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CrossIconWrap, {
              onClick: handleClick,
              "data-test-id": "RegionModalDweb-CrossIconWrap",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                width: "28px",
                height: "28px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
                "data-test-id": "RegionModalDweb-ImageComponent"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: "xlarge",
            fontWeight: "black",
            "data-test-id": "RegionModalDweb-ParaTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: customTitle,
              "data-test-id": "RegionModalDweb-FormattedText"
            })
          })]
        })
      }), children]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.BackDropComp, {
      onClose: handleClick,
      "data-test-id": "RegionModalDweb-BackDropComp"
    })]
  });
};

/* harmony default export */ const RegionModalDweb_RegionModalDweb = (RegionModalDweb);

/***/ }),

/***/ 61643:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27481);
/* harmony import */ var _FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17871);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);





const RichText = ({
  value
}) => {
  if (typeof value === "string") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_MarkdownText_MarkdownText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      value: value,
      "data-test-id": "RichText-MarkdownText"
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_FormattedText_FormattedText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    value: value,
    "data-test-id": "RichText-FormattedText"
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RichText);

/***/ })

}]);